// All Section data goes here
let SectionData = {
  logoData: [
    {
      imgClass: "logo-dark",
      logoImg: require("@/images/logo-black.png"),
      path: "/home",
    },
    {
      imgClass: "logo-light",
      logoImg: require("@/images/logo-white.png"),
      path: "/home",
    },
  ],
  // Hero data
  heroData: {
    time: "2022-5-30 23:30:00",
    subTitle: "auction ending in",
    title: "Swimming into this amazing world",
    subTitleTwo: "current bid",
    heroPrice: "3.069 ETH",
    heroPriceTwo: "$10,814.02",
    img: require("@/images/thumb/nft.jpg"),
  },
  // Hero data two
  heroDataTwo: {
    title: "Create, sell or collect digital items",
    content: "Complete account of the system, and expound the actual teachings of the great explorer of human happiness.",
    img: require("@/images/thumb/nft-img.png"),
  },
  // Hero data three
  heroDataThree: {
    title: "Discover rare artworks by world class artists",
    content: "EnftyMart, a Global B2B SaaS, empowers you to launch your own white-label NFT store or NFT Marketplace without any technical knowledge",
  },
  // Hero data four
  heroDataFour: {
    title: "Explore Thousands of Digital Arts and Collectibles",
    subTitle: "largest nft marketplace",
  },
  // Hero data Five
  heroDataFive: {
    title: "Search, Explore and Sell your Specific artworks",
    content: "If you are working with any type of Digital NFT Marketplace, NFT Consulting, and Development Firm for every industry then EnftyMart is the best choise to launch your website.",
  },
  // Hero data Six
  heroDataSix: {
    title: "Discover, collect, and sell extraordinary NFT's Assets",
    content: "We are all new crypto-collectibles marketplace from arts, music, games to domains, and many more in the list. Now you can buy & sell rare items.",
  },
  // Hero data Eight
  heroDataEight: [
    {
      id: 1,
      img: require("@/images/thumb/nft-full1.jpg"),
      title: "创造, 合作, 让你们花费的时间与精力得到价值",
      content: "一个热爱集结之地，充斥合作与竞争，平衡或许就在你来我往之间",
    },
    {
      id: 2,
      img: require("@/images/thumb/nft-fullTwo.jpg"),
      title: "Exclusive digital asset",
      content: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some.",
    },
    {
      id: 3,
      img: require("@/images/thumb/nft-fullThree.jpg"),
      title: "NFT Marketplace Explore, collect, and sell NFTs",
      content: "If you are working with any type of Digital NFT Marketplace, and Development Firm for every industry then EnftyMat.",
    },
  ],
  // Breadcrumb data
  breadcrumbData: {
    breadcrumbList: {
      title: "探索",
      navList: [
        {
          title: "探索",
        },
      ],
    },
    breadcrumbListTwo: {
      title: "Activity",
      navList: [
        {
          title: "Activity",
        },
      ],
    },
    breadcrumbListThree: {
      title: "Ranking",
      navList: [
        {
          title: "Ranking",
        },
      ],
    },
    breadcrumbListFour: {
      title: "Connect Wallet",
      navList: [
        {
          title: "Wallet",
        },
      ],
    },
    breadcrumbListFive: {
      title: "Private Gallery",
      navList: [
        {
          title: "Private Gallery",
        },
      ],
    },
    breadcrumbListExhibition: {
      title: "Exhibition",
      navList: [
        {
          title: "Exhibition",
        },
      ],
    },
    breadcrumbListPrivateCreate: {
      title: "Private Gallery Create",
      navList: [
        {
          title: "Private Gallery Create",
        },
      ],
    },
    breadcrumbListSix: {
      title: "Enter Linda Dounia's Cyber Baat World",
      navList: [
        {
          title: "Blog",
        },
        {
          title: "Enter Linda Dounia...",
        },
      ],
    },
    breadcrumbListSeven: {
      title: "How can we help?",
      navList: [
        {
          title: "Contact",
        },
      ],
    },
  },
  // Button group data
  btnData: [
    {
      btnClass: "btn-primary",
      title: "Place Bid",
      path: "/product-details-v1-1",
    },
    {
      btnClass: "bg-dark-dim",
      title: "View",
      titleTwo: "Artwork",
      path: "/explore",
    },
  ],
  // Hero btn data
  btnDataTwo: [
    {
      btnClass: "btn-lg btn-dark",
      title: "Place a Bid",
      path: "/product-details-v1-1",
    },
    {
      btnClass: "btn-lg bg-dark-dim",
      title: "View Artwork",
      path: "/explore",
    },
  ],
  // Hero btn data
  btnDataThree: [
    {
      btnClass: "btn-lg btn-dark",
      title: "Explore",
      path: "/explore",
    },
    {
      btnClass: "btn-lg btn-outline-dark",
      title: "Create",
      path: "/create",
    },
  ],
  // Hero btn data
  btnDataFour: [
    {
      btnClass: "btn-lg btn-grad",
      title: "Register Now",
      path: "register",
    },
    {
      btnClass: "btn-lg btn-outline-dark",
      title: "Create Store",
      path: "/create",
    },
  ],
  // Header data
  headerData: {
    // 헤더 목록 리스트
    btnText: "个人主页",
    inputPlaceholderText: "这里搜索",
    menuList: {
      title: "Home",
      navList: [
        {
          id: 1,
          title: "Home Page 1",
          path: "/",
        },
      ],
    },
    menuList2: {
      title: "参观",
      navList: [
        {
          id: 1,
          title: "参观",
          path: "/exhibition",
        },
        {
          id: 2,
          title: "私人画廊",
          path: "/privateGallery",
          badgeClass: "badge text-primary bg-primary-50",
        },
      ],
    },
    menuList3: {
      title: "市场",
      navList: [
        {
          id: 1,
          title: "Explore",
          path: "/explore",
        },
        {
          id: 2,
          title: "Explore v2",
          path: "/explore-v2",
        },
      ],
    },
    menuList4: {
      title: "我的",
      navList: [
        {
          id: 1,
          title: "profile",
          path: "/profile",
        },
      ],
    },
    menuList5: {
      title: "登陆",
      navList: [
        {
          id: 1,
          title: "登陆",
          path: "/login",
        },
      ],
    },
  },
  // Product data
  productData: {
    title: "热门",
    content: "这里是像素市场。你可以在YOOCH Market！中浏览商品！。单击以转到产品详细信息页面。",
    contentTwo: "Explore on the world's best NFT marketplace with our beautiful NFT products. We want to be a part of your smile.",
    btnText: "查看市场所有part",
    btnLink: "/explore",
    btnLinkTwo: "/explore-v3",
    btnLinkThree: "/explore-v4",
    
    btnLinkFour: "/explore-v5",
    btnLinkFive: "/explore-v6",
    btnTextTwo: "Load More",
    meta: "NTFs Products",
    products: [
      {
        id: 1,
        img: require("@/images/thumb/nft-full.0609d1e0.jpg"),
        imgLg: require("@/images/thumb/nft-full.0609d1e0.jpg"),
        title: "One Tribe Black Edition",
        content: 'Digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "ZeniconStudio",
        authorLink: "/author",
        price: 14,
        priceTwo: 1.32,
        metaText: "Not for sale",
        metaTextTwo: "500 editions",
        metaTextThree: "500 editions",
        avatar: require("@/images/thumb/avatar.jpg"),
        userName: "@zenicon_studio",
        followersText: "1.3k Followers",
        authorName: "Zenicon Studio",
        desc: "Complete account of the system, and expound the actual things.",
        name: "art",
        category: "art",
        itemToShow: "show",
        itemToShowTwo: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 2,
        img: require("@/images/thumb/nft-full-2.8a0adca0.jpg"),
        imgLg: require("@/images/thumb/nft-lg2.jpg"),
        title: "Operation Jade Fury",
        content: "Bazzors is a tiny buzzing, electrifying and irascible Elfin. Bazzors appear intermittently during thunderstorms in the Elfin Kingdom ",
        author: "CanvaNetwork",
        authorLink: "/author",
        price: 10,
        priceTwo: 0.32,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-2.jpg"),
        userName: "@canva_network",
        followersText: "1.3k Followers",
        authorName: "Canva Network",
        desc: "Complete account of the system, and expound the actual things.",
        name: "music",
        category: "music",
        itemToShow: "show",
        itemToShowTwo: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 3,
        img: require("@/images/thumb/nft4.jpg"),
        imgLg: require("@/images/thumb/nft-lg3.jpg"),
        title: "Unboxing The Compass",
        content: "According to our idea, REAL BORED APE would look exactly like this. Have you ever seen this tough guy on the streets of your city?",
        author: "MoveNetwork",
        authorLink: "/author",
        price: 8.0,
        priceTwo: 0.32,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-3.jpg"),
        userName: "@move_network",
        followersText: "1.3k Followers",
        authorName: "Move Network",
        desc: "Complete account of the system, and expound the actual things.",
        name: "music",
        category: "music",
        itemToShow: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 4,
        img: require("@/images/thumb/nft5.jpg"),
        imgLg: require("@/images/thumb/nft-lg4.jpg"),
        title: "Rendering by the Water",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "RukiStudio",
        authorLink: "/author",
        price: 11.0,
        priceTwo: 0.32,
        metaText: "Not for sale",
        metaTextTwo: "300 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-4.jpg"),
        userName: "@ruki_studio",
        followersText: "1.3k Followers",
        authorName: "Ruki Studio",
        desc: "Complete account of the system, and expound the actual things.",
        name: "music",
        category: "music",
        itemToShow: "show",
        itemToShowSingle: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 5,
        img: require("@/images/thumb/nft6.jpg"),
        imgLg: require("@/images/thumb/nft-lg5.jpg"),
        title: "Divine Opulence",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "DvisionNetwork",
        authorLink: "/author",
        price: 12.0,
        priceTwo: 1.44,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">2.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-5.jpg"),
        userName: "@dvison_network",
        followersText: "2.4k Followers",
        authorName: "Dvision Network",
        desc: "Complete account of the system, and expound the actual things.",
        name: "art",
        category: "art",
        itemToShow: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 6,
        img: require("@/images/thumb/nft7.jpg"),
        imgLg: require("@/images/thumb/nft-lg6.jpg"),
        title: "Sacral Metatron Cube",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "KamranMedia",
        authorLink: "/author",
        price: 11.0,
        priceTwo: 2.33,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-6.jpg"),
        userName: "@kamran_media",
        followersText: "2.4k Followers",
        authorName: "Kamran Media",
        desc: "Complete account of the system, and expound the actual things.",
        name: "art",
        category: "art",
        itemToShow: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 7,
        img: require("@/images/thumb/nft8.jpg"),
        imgLg: require("@/images/thumb/nft-lg7.jpg"),
        title: "Girl warming up to a bed acrobat",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "JisanMedia",
        authorLink: "/author",
        price: 8.0,
        priceTwo: 0.33,
        metaText: "Not for sale",
        metaTextTwo: "100 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-7.jpg"),
        userName: "@jisan_media",
        followersText: "2.4k Followers",
        authorName: "Jisan Media",
        desc: "Complete account of the system, and expound the actual things.",
        name: "art",
        category: "art",
        itemToShow: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 8,
        img: require("@/images/thumb/nft9.jpg"),
        imgLg: require("@/images/thumb/nft-lg8.jpg"),
        title: "Women Eyes Modern Art",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "RifiUnited",
        authorLink: "/author",
        price: 8.0,
        priceTwo: 0.33,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-8.jpg"),
        userName: "@rifi_united",
        followersText: "1.4k Followers",
        authorName: "Rifi United",
        desc: "Complete account of the system, and expound the actual things.",
        name: "collectibles",
        category: "collectibles",
        itemToShow: "show",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 9,
        img: require("@/images/thumb/nft16.jpg"),
        imgLg: require("@/images/thumb/nft-lg9.jpg"),
        title: "Puffy Baby Bird #151",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "RadioCaca",
        authorLink: "/author",
        price: 12.0,
        priceTwo: 1.33,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-9.jpg"),
        userName: "@radio_caca",
        followersText: "1.4k Followers",
        authorName: "Radio Caca",
        desc: "Complete account of the system, and expound the actual things.",
        name: "collectibles",
        category: "collectibles",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 10,
        img: require("@/images/thumb/nft17.jpg"),
        imgLg: require("@/images/thumb/nft-lg10.jpg"),
        title: "Wave1 - Titanium Ticket",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "InfinityArt",
        authorLink: "/author",
        price: 10.0,
        priceTwo: 0.33,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-10.jpg"),
        userName: "@infinity_art",
        followersText: "1.4k Followers",
        authorName: "Infinity Art",
        desc: "Complete account of the system, and expound the actual things.",
        name: "collectibles",
        category: "collectibles",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 11,
        img: require("@/images/thumb/nft18.jpg"),
        imgLg: require("@/images/thumb/nft-lg11.jpg"),
        title: "Saggezza 2/4. Cartier Edition",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "InfinityArt",
        authorLink: "/author",
        price: 5.0,
        priceTwo: 1.33,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">2.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-11.jpg"),
        userName: "@infinity_art",
        followersText: "1.4k Followers",
        authorName: "Infinity Art",
        desc: "Complete account of the system, and expound the actual things.",
        name: "games",
        category: "games",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
      {
        id: 12,
        img: require("@/images/thumb/nft19.jpg"),
        imgLg: require("@/images/thumb/nft-lg12.jpg"),
        title: "Venus (Viktoria Veisbrut & SoldArt)",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "Viktoria",
        authorLink: "/author",
        price: 12.0,
        priceTwo: 1.33,
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
        avatar: require("@/images/thumb/avatar-12.jpg"),
        userName: "@viktoria",
        followersText: "1.4k Followers",
        authorName: "Viktoria",
        desc: "Complete account of the system, and expound the actual things.",
        name: "games",
        category: "games",
        avatars: [
          {
            id: 1,
            img: require("@/images/thumb/avatar.jpg"),
            path: "/author",
          },
          {
            id: 2,
            img: require("@/images/thumb/avatar-2.jpg"),
            path: "/author",
          },
          {
            id: 3,
            img: require("@/images/thumb/avatar-3.jpg"),
            path: "/author",
          },
          {
            id: 4,
            img: require("@/images/thumb/avatar-4.jpg"),
            path: "/author",
          },
          {
            id: 5,
            img: require("@/images/thumb/avatar-5.jpg"),
            path: "/author",
          },
        ],
      },
    ],
    onSaleList: [
      {
        id: 1,
        img: require("@/images/thumb/nft-2.jpg"),
        imgLg: require("@/images/thumb/nft-lg.jpg"),
        title: "One Tribe Black Edition",
        content: 'Digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "ZeniconStudio",
        authorLink: "/author",
        price: "14.20",
        priceTwo: "1.32",
        metaText: "Not for sale",
        metaTextTwo: "500 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">0.072 ETH</span>',
      },
      {
        id: 2,
        img: require("@/images/thumb/nft-full-2.8a0adca0.jpg"),
        imgLg: require("@/images/thumb/nft-full-2.8a0adca0.jpg"),
        title: "Operation Jade Fury",
        content: "Bazzors is a tiny buzzing, electrifying and irascible Elfin. Bazzors appear intermittently during thunderstorms in the Elfin Kingdom ",
        author: "CanvaNetwork",
        authorLink: "/author",
        price: "10.00",
        priceTwo: "0.32",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 3,
        img: require("@/images/thumb/nft4.jpg"),
        imgLg: require("@/images/thumb/nft-lg3.jpg"),
        title: "Unboxing The Compass",
        content: "According to our idea, REAL BORED APE would look exactly like this. Have you ever seen this tough guy on the streets of your city?",
        author: "MoveNetwork",
        authorLink: "/author",
        price: "8.00",
        priceTwo: "0.32",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 4,
        img: require("@/images/thumb/nft5.jpg"),
        imgLg: require("@/images/thumb/nft-lg4.jpg"),
        title: "Rendering by the Water",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "RukiStudio",
        authorLink: "/author",
        price: "11.00",
        priceTwo: "0.32",
        metaText: "Not for sale",
        metaTextTwo: "300 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 5,
        img: require("@/images/thumb/nft6.jpg"),
        imgLg: require("@/images/thumb/nft-lg5.jpg"),
        title: "Divine Opulence",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "DvisionNetwork",
        authorLink: "/author",
        price: "12.00",
        priceTwo: "1.44",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">2.072 ETH</span>',
      },
      {
        id: 6,
        img: require("@/images/thumb/nft7.jpg"),
        imgLg: require("@/images/thumb/nft-lg6.jpg"),
        title: "Sacral Metatron Cube",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "KamranMedia",
        authorLink: "/author",
        price: "11.00",
        priceTwo: "2.33",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
    ],
    ownedList: [
      {
        id: 1,
        img: require("@/images/thumb/nft4.jpg"),
        imgLg: require("@/images/thumb/nft-lg3.jpg"),
        title: "Unboxing The Compass",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "ZeniconStudio",
        authorLink: "/author",
        price: "14.20",
        priceTwo: "1.32",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 2,
        img: require("@/images/thumb/nft5.jpg"),
        imgLg: require("@/images/thumb/nft-lg4.jpg"),
        title: "Rendering by the Water",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "ZeniconStudio",
        authorLink: "/author",
        price: "14.20",
        priceTwo: "1.32",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 3,
        img: require("@/images/thumb/nft-2.jpg"),
        imgLg: require("@/images/thumb/nft-lg.jpg"),
        title: "One Tribe Black Edition",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "ZeniconStudio",
        authorLink: "/author",
        price: "14.20",
        priceTwo: "1.32",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 4,
        img: require("@/images/thumb/nft3.jpg"),
        imgLg: require("@/images/thumb/nft-lg2.jpg"),
        title: "Operation Jade Fury",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "ZeniconStudio",
        authorLink: "/author",
        price: "14.20",
        priceTwo: "1.32",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 5,
        img: require("@/images/thumb/nft6.jpg"),
        imgLg: require("@/images/thumb/nft-lg5.jpg"),
        title: "Divine Opulence",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "DvisionNetwork",
        authorLink: "/author",
        price: "12.00",
        priceTwo: "1.44",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
      {
        id: 6,
        img: require("@/images/thumb/nft7.jpg"),
        imgLg: require("@/images/thumb/nft-lg6.jpg"),
        title: "Sacral Metatron Cube",
        content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
        author: "KamranMedia",
        authorLink: "/author",
        price: "11.00",
        priceTwo: "1.44",
        metaText: "Not for sale",
        metaTextTwo: "200 editions",
        metaTextThree: 'Highest bid <span class="text-primary fw-semibold">1.072 ETH</span>',
      },
    ],
  },
  // Related Product data
  relatedProductData: {
    title: "Popular Art Assets",
  },
  // creator data
  creatorData: {
    title: "Featured Creators",
    meta: "Our Creators",
    content: "Explore on the world's best NFT marketplace with our beautiful NFT products creators. We want to be a part of your smile.",
    creatorList: [
      {
        id: 1,
        title: "@nathan_walls",
        subTitle: "24.13 ETH",
        img: require("@/images/thumb/avatar.jpg"),
        path: "/author",
      },
      {
        id: 2,
        title: "@alex_smith",
        subTitle: "12.24 ETH",
        img: require("@/images/thumb/avatar-2.jpg"),
        path: "/author",
      },
      {
        id: 3,
        title: "@kevin_martin",
        subTitle: "13.57 ETH",
        img: require("@/images/thumb/avatar-3.jpg"),
        path: "/author",
      },
      {
        id: 4,
        title: "@david_martin",
        subTitle: "34.13 ETH",
        img: require("@/images/thumb/avatar-4.jpg"),
        path: "/author",
      },
      {
        id: 5,
        title: "@jhonatan_doe",
        subTitle: "23.24 ETH",
        img: require("@/images/thumb/avatar-5.jpg"),
        path: "/author",
      },
      {
        id: 6,
        title: "@mark_hardson",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-6.jpg"),
        path: "/author",
      },
    ],
    creatorListTwo: [
      {
        id: 1,
        title: "Nathan Walls",
        subTitle: "24.13 ETH",
        img: require("@/images/thumb/avatar.jpg"),
        path: "/author",
      },
      {
        id: 2,
        title: "Alex Smith",
        subTitle: "12.24 ETH",
        img: require("@/images/thumb/avatar-2.jpg"),
        path: "/author",
      },
      {
        id: 3,
        title: "Kevin Martin",
        subTitle: "13.57 ETH",
        img: require("@/images/thumb/avatar-3.jpg"),
        path: "/author",
      },
      {
        id: 4,
        title: "David Martin",
        subTitle: "34.13 ETH",
        img: require("@/images/thumb/avatar-4.jpg"),
        path: "/author",
      },
      {
        id: 5,
        title: "Jhonatan Doe",
        subTitle: "23.24 ETH",
        img: require("@/images/thumb/avatar-5.jpg"),
        path: "/author",
      },
      {
        id: 6,
        title: "Mark Hardson",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-6.jpg"),
        path: "/author",
      },
      {
        id: 7,
        title: "Gayle Hicks",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-7.jpg"),
        path: "/author",
      },
      {
        id: 8,
        title: "Claude Banks",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-8.jpg"),
        path: "/author",
      },
      {
        id: 9,
        title: "Stacy Long",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-9.jpg"),
        path: "/author",
      },
      {
        id: 10,
        title: "Fred Ryan",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-10.jpg"),
        path: "/author",
      },
      {
        id: 11,
        title: "Franklin Greer",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-11.jpg"),
        path: "/author",
      },
      {
        id: 12,
        title: "Karla Sharp",
        subTitle: "34.57 ETH",
        img: require("@/images/thumb/avatar-12.jpg"),
        path: "/author",
      },
    ],
  },
  // collection data
  collectionData: {
    title: "Collections",
    collectionList: [
      {
        id: 1,
        title: "Crappy Dogecoin",
        price: "$26,220",
        img: require("@/images/thumb/art-5.jpg"),
        avatar: require("@/images/thumb/avatar.jpg"),
        path: "",
      },
      {
        id: 2,
        title: "Savage Dogs",
        price: "$24,497",
        img: require("@/images/thumb/art-6.jpg"),
        avatar: require("@/images/thumb/avatar-2.jpg"),
        path: "",
      },
      {
        id: 3,
        title: "Crappy Dogecoin",
        price: "$26,220",
        img: require("@/images/thumb/art-7.jpg"),
        avatar: require("@/images/thumb/avatar-3.jpg"),
        path: "",
      },
      {
        id: 4,
        title: "Crypto Krills",
        price: "$11,356",
        img: require("@/images/thumb/art-8.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        path: "",
      },
      {
        id: 5,
        title: "Chibi Doge",
        price: "$4,234",
        img: require("@/images/thumb/art-9.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        path: "",
      },
    ],
  },
  sellBuyData: [
    {
      id: 1,
      img: require("@/images/thumb/buy.png"),
      title: "Buy NFT Products",
      content: "Purchase digital NFT products from the biggest directory.",
      btnText: "Get Started",
      btnLink: "/register",
    },
    {
      id: 2,
      img: require("@/images/thumb/sell.png"),
      title: "Sell Your NFT Products",
      content: "Sell one of your NFT products to make a huge profit.",
      btnText: "Start Selling",
      btnLink: "/create",
    },
  ],
  // itemDetail data
  itemDetailData: {
    img: require("@/images/thumb/nft-lg.jpg"),
    imgTwo: require("@/images/thumb/item-detail-2.jpg"),
    title: "The Future is Blossoming - Harlows 2021",
    content: 'Limited Edition *digital-only* "CB Galaxy" style Coke Boys LA sneakers wearable in the Decentraland metaverse',
    metaText: "Not for sale",
    metaTextTwo: "500 editions",
    metaTextThree: "Highest bid 0.072 ETH",
    btnText: "Place a Bid",
    btnTextTwo: "Share",
    itemDetailTabNav: [
      {
        id: 1,
        isActive: "active",
        title: "Owners",
        slug: "owners-tab",
        bsTarget: "#owners",
      },
      {
        id: 2,
        title: "History",
        slug: "history-tab",
        bsTarget: "#history",
      },
      {
        id: 3,
        title: "Detail",
        slug: "detail-tab",
        bsTarget: "#detail",
      },
    ],
    itemDetailOwnerList: [
      {
        id: 1,
        title: "French Montana",
        subTitle: "450 editions not for sale",
        avatar: require("@/images/thumb/avatar-4.jpg"),
        path: "/author",
      },
      {
        id: 2,
        title: "Beejaey",
        subTitle: "6 editions not for sale",
        avatar: require("@/images/thumb/avatar-5.jpg"),
        path: "/author",
      },
      {
        id: 3,
        title: "Tom Dracula",
        subTitle: "24 editions not for sale",
        avatar: require("@/images/thumb/avatar-6.jpg"),
        path: "/author",
      },
    ],
    itemDetailOwnerListTwo: {
      title: "Owners",
      ownerList: [
        {
          id: 1,
          title: "French Montana",
          subTitle: "450 editions not for sale",
          avatar: require("@/images/thumb/avatar-4.jpg"),
          path: "/author",
        },
        {
          id: 2,
          title: "Beejaey",
          subTitle: "6 editions not for sale",
          avatar: require("@/images/thumb/avatar-5.jpg"),
          path: "/author",
        },
        {
          id: 3,
          title: "Tom Dracula",
          subTitle: "24 editions not for sale",
          avatar: require("@/images/thumb/avatar-6.jpg"),
          path: "/author",
        },
      ],
    },
    itemDetailBidsList: [
      {
        id: 1,
        title: "0.072 ETH by Palliman for 1 edition",
        date: "21/09/2021",
        avatar: require("@/images/thumb/avatar.jpg"),
        path: "/author",
      },
      {
        id: 2,
        title: "0.072 ETH by KingKhalid for 1 edition",
        date: "14/08/2021",
        avatar: require("@/images/thumb/avatar-2.jpg"),
        path: "/author",
      },
      {
        id: 3,
        title: "0.072 ETH by Kamran for 1 edition",
        date: "12/07/2021",
        avatar: require("@/images/thumb/avatar-3.jpg"),
        path: "/author",
      },
    ],
    itemDetailBidsListTwo: {
      title: "Bids",
      bidsList: [
        {
          id: 1,
          title: "0.072 ETH by Palliman for 1 edition",
          date: "21/09/2021",
          avatar: require("@/images/thumb/avatar.jpg"),
          path: "/author",
        },
        {
          id: 2,
          title: "0.072 ETH by KingKhalid for 1 edition",
          date: "14/08/2021",
          avatar: require("@/images/thumb/avatar-2.jpg"),
          path: "/author",
        },
        {
          id: 3,
          title: "0.072 ETH by Kamran for 1 edition",
          date: "12/07/2021",
          avatar: require("@/images/thumb/avatar-3.jpg"),
          path: "/author",
        },
      ],
    },
    itemDetailHistoryList: [
      {
        id: 1,
        title: "Listed 1 edition for 0.35 ETH",
        subTitle: "by Medicom 21 hours ago",
        avatar: require("@/images/thumb/avatar-4.jpg"),
        path: "/author",
      },
      {
        id: 2,
        title: "Purchased 1 edition for 0.1 ETH",
        subTitle: "by Medicom 21 hours ago",
        avatar: require("@/images/thumb/avatar-5.jpg"),
        path: "/author",
      },
      {
        id: 3,
        title: "Purchased 1 edition for 0.1 ETH",
        subTitle: "by French Montana 23/09/2021",
        avatar: require("@/images/thumb/avatar-6.jpg"),
        path: "/author",
      },
    ],
    itemDetailHistoryListTwo: {
      title: "History",
      historyList: [
        {
          id: 1,
          title: "Listed 1 edition for 0.35 ETH",
          subTitle: "by Medicom 21 hours ago",
          avatar: require("@/images/thumb/avatar-4.jpg"),
          path: "/author",
        },
        {
          id: 2,
          title: "Purchased 1 edition for 0.1 ETH",
          subTitle: "by Medicom 21 hours ago",
          avatar: require("@/images/thumb/avatar-5.jpg"),
          path: "/author",
        },
        {
          id: 3,
          title: "Purchased 1 edition for 0.1 ETH",
          subTitle: "by French Montana 23/09/2021",
          avatar: require("@/images/thumb/avatar-6.jpg"),
          path: "/author",
        },
      ],
    },
    itemDetailList: [
      {
        id: 1,
        title: "@nathan_walls",
        subTitle: "Creator",
        avatar: require("@/images/thumb/avatar.jpg"),
        path: "/author",
      },
      {
        id: 2,
        title: "@kamran_ahmed",
        subTitle: "Collection",
        avatar: require("@/images/thumb/avatar-2.jpg"),
        path: "/author",
      },
    ],
    itemDetailListTwo: [
      {
        title: "Highest bid by Palliman",
        titleTwo: "Palliman",
        subTitle: "0.072 ETH",
        avatar: require("@/images/thumb/avatar-3.jpg"),
        path: "/author",
      },
    ],
  },
  // Freatured creator data
  featuredCreatorsData: {
    title: "Featured Creators",
    content: "This is just a simple text made for this unique and awesome template, you can replace it with any text. It is a long established fact.",
    btnText: "View all creators",
    featuredList: [
      {
        id: 1,
        img: require("@/images/thumb/art.jpg"),
        avatar: require("@/images/thumb/avatar.jpg"),
        title: "Takeshi Murata",
        content: "Complete account of the system, and expound the actual things.",
        followerNum: "756",
        followerText: "Followers",
        followingNum: "30",
        followingText: "Following",
        soldText: "3.45 ETH Last Sold",
        followText: "Follow",
        btnLink: "/author",
      },
      {
        id: 2,
        img: require("@/images/thumb/art-2.jpg"),
        avatar: require("@/images/thumb/avatar-2.jpg"),
        title: "Alex Smith",
        content: "Complete account of the system, and expound the actual things.",
        followerNum: "202",
        followerText: "Followers",
        followingNum: "10",
        followingText: "Following",
        soldText: "1.23 ETH Last Sold",
        followText: "Follow",
        btnLink: "/author",
      },
      {
        id: 3,
        img: require("@/images/thumb/art-3.jpg"),
        avatar: require("@/images/thumb/avatar-3.jpg"),
        title: "Kevin Martin",
        content: "Complete account of the system, and expound the actual things.",
        followerNum: "343",
        followerText: "Followers",
        followingNum: "50",
        followingText: "Following",
        soldText: "23.34 ETH Last Sold",
        followText: "Follow",
        btnLink: "/author",
      },
      {
        id: 4,
        img: require("@/images/thumb/art-4.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Jhonatan Doe",
        content: "Complete account of the system, and expound the actual things.",
        followerNum: "315",
        followerText: "Followers",
        followingNum: "80",
        followingText: "Following",
        soldText: "2.34 ETH Last Sold",
        followText: "Follow",
        btnLink: "/author",
      },
    ],
  },
  // Freatured data
  featuredData: {
    title: "Exclusive EnftyMart drops",
    content: "This is just a simple text made for this unique and awesome template, you can replace it with any text. It is a long established fact.",
    featuredList: [
      {
        id: 1,
        img: require("@/images/thumb/art.jpg"),
        title: "Seasons by AlexSmith",
        content: "AlexSmith's Summer Collection featuring Time",
        path: "/item-details",
      },
      {
        id: 2,
        img: require("@/images/thumb/art-2.jpg"),
        title: "Kavin Martin EnftyMart.io",
        content: "After a sold-out Art Blocks drop, Martin is back with",
        path: "/item-details",
      },
      {
        id: 3,
        img: require("@/images/thumb/art-3.jpg"),
        title: "Kavin Martin EnftyMart.io",
        content: "After a sold-out Art Blocks drop, Martin is back with",
        path: "/item-details",
      },
      {
        id: 4,
        img: require("@/images/thumb/art-4.jpg"),
        title: "Tyronejkd Universe",
        content: "After a sold-out Art Blocks drop, Martin is back with",
        path: "/item-details",
      },
    ],
  },
  // counter item data
  countItemData: [
    {
      id: 1,
      title: "259K+",
      text: "NFTs Minted",
      className: "col-6",
    },
    {
      id: 2,
      title: "$11M+",
      text: "Trading Volume",
      className: "col-6",
    },
    {
      id: 3,
      title: "24K+",
      text: "Creative Creators",
    },
  ],
  // Recent item data
  recentItemData: {
    title: "Recently Created",
    content: "This is just a simple text made for this unique and awesome template, you can replace it with any text. It is a long established fact.",
  },
  // how It Work Data
  howItWorkData: {
    title: "创建与分享你们的作品",
    content: "欢迎来到YOOCH，在这里你们可以一起在一个巨大的画布中用像素创造你们喜欢的图案，你所放置的每一个像素都归你个人所有，但是不保证别人会不会覆盖你的像素",
    titleTwo: "你可以将你自己的像素分享给别人，最终得到一个完整的作品",
    titleThree: "只要简单几步就可以实现",
    btnText: "Create Store",
    howItWorkList: [
      {
        id: 1,
        icon: "icon ni ni-wallet icon-lg icon-circle shadow-sm icon-wbg mx-auto mb-4 text-primary",
        title: "和你的伙伴一起放置像素",
        content: "你的伙伴越多，你们的画就可以越大且可以通过你们的努力免受坏蛋覆盖",
      },
      {
        id: 2,
        icon: "icon ni ni-file-text icon-lg icon-circle shadow-sm icon-wbg mx-auto mb-4",
        title: "申请保护",
        content: '当你们的画作完成时，可以申请网站保护，审核通过后，每个参与的成员都会在自己的仓库中看见自己放置的像素，那些都是你个人拥有的',
      },
      {
        id: 3,
        icon: "icon ni ni-camera icon-lg icon-circle shadow-sm icon-wbg mx-auto mb-4",
        title: "交易",
        content: "你所拥有的像素会以一次画作为分组，他们都有自己的专属编号，可以通过市场赠予给其他人",
      },
      {
        id: 4,
        icon: "icon ni ni-money icon-lg icon-circle shadow-sm icon-wbg mx-auto mb-4",
        title: "合成",
        content: "当一个人集齐某个画作系列的全部像素，就可以合成为一幅完整的画作，每一次合成都会占用一个顺位编号，每个画作有限",
      },
    ],
    howItWorkListTwo: [
      {
        id: 1,
        icon: "icon ni ni-wallet icon-md icon-rounded icon-wbg mx-auto mb-4 text-white bg-blue",
        title: "Set up your wallet",
      },
      {
        id: 2,
        icon: "icon ni ni-file-text icon-md icon-rounded icon-wbg mx-auto mb-4 text-white bg-purple",
        title: "Create collection",
      },
      {
        id: 3,
        icon: "icon ni ni-camera icon-md icon-rounded icon-wbg mx-auto mb-4 text-white bg-pink",
        title: "Add your NFTs",
      },
      {
        id: 4,
        icon: "icon ni ni-money icon-md icon-rounded icon-wbg mx-auto mb-4 text-white bg-orange",
        title: "List them for sale",
      },
    ],
    howItWorkListThree: [
      {
        id: 1,
        icon: "icon ni ni-wallet icon-md icon-circle icon-wbg me-3 text-blue bg-blue-100",
        title: "Set up your wallet",
        content: "Once you’ve set up your wallet of choice, connect it to EnftyMart by clicking the wallet icon.",
      },
      {
        id: 2,
        icon: "icon ni ni-file-text icon-md icon-circle icon-wbg me-3 text-purple bg-purple-100",
        title: "Create collection",
        content: 'Click <a href="/profile" class="btn-link">My Collections</a> and set up your collection. Add social links, a description of item.',
      },
      {
        id: 3,
        icon: "icon ni ni-camera icon-md icon-circle icon-wbg me-3 text-pink bg-pink-100",
        title: "Add your NFTs",
        content: "Upload your work (image, video, audio, or 3D art), add a title and description to item.",
      },
      {
        id: 4,
        icon: "icon ni ni-money icon-md icon-circle icon-wbg me-3 text-orange bg-orange-100",
        title: "List them for sale",
        content: "Choose between auctions, fixed-price listings, and declining-price listings of item.",
      },
    ],
    howItWorkListFour: [
      {
        id: 1,
        title: "What is a non-fungible token (NFT)?",
        content: "A non-fungible token (NFT) is a cryptographic token that represents a unique asset. They function as verifiable proofs of authenticity and ownership within a blockchain network.",
      },
      {
        id: 2,
        title: "What is EnftyMart NFT Marketplace?",
        content: "EnftyMart NFT Marketplace brings together artists, creators, and crypto enthusiasts on a single platform to create and trade top NFTs. The platform features 3 product lines.",
      },
      {
        id: 3,
        title: "How do I create an NFT?",
        content: "Click [Create] and choose your file to upload. We currently support JPG, PNG, GIF, PDF, MP4, MP3, MPEG, AVI, WAV, and SVG. Please note that your NFT cannot be changed.",
      },
      {
        id: 4,
        title: "How do I buy an NFT?",
        content: "For NFTs with a fixed price, click the [Buy] button on the product page and complete the transaction. Once the transaction is successful, we will transfer the NFT to your wallet.",
      },
      {
        id: 5,
        title: "How do I sell an NFT?",
        content: "To list an NFT for sale, our team will first of all approve the content to make sure it’s appropriate for listing. This process usually takes 4-8 hours. Upon successful approval.",
      },
    ],
    tabNav: [
      {
        id: 1,
        isActive: "active",
        title: "Connect Your Wallet",
        slug: "pills-connect-wallet-tab",
        bsTarget: "#pills-connect-wallet",
      },
      {
        id: 2,
        title: "Create Your NFT Store",
        slug: "pills-create-nft-store-tab",
        bsTarget: "#pills-create-nft-store",
      },
      {
        id: 3,
        title: "Start Selling & Growing",
        slug: "pills-start-selling-tab",
        bsTarget: "#pills-start-selling",
      },
    ],
  },
  // Category Data
  categoryData: {
    title: "Browse by category",
    content: "This is just a simple text made for this unique and awesome template, you can replace it with any text. It is a long established fact.",
    categoryList: [
      {
        id: 1,
        class: "text-purple",
        icon: "icon ni ni-camera mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Artwork",
        path: "/explore",
      },
      {
        id: 2,
        class: "text-blue",
        icon: "icon ni ni-music mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Music",
        path: "/explore",
      },
      {
        id: 3,
        class: "text-pink",
        icon: "icon ni ni-search mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Domain Names",
        path: "/explore",
      },
      {
        id: 4,
        class: "text-orange",
        icon: "icon ni ni-globe mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Virtual Worlds",
        path: "/explore",
      },
      {
        id: 5,
        class: "text-yellow",
        icon: "icon ni ni-user mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Trending Cards",
        path: "/explore",
      },
      {
        id: 6,
        class: "text-green",
        icon: "icon ni ni-opt-alt-fill mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Collectibles",
        path: "/explore",
      },
      {
        id: 7,
        class: "text-teal",
        icon: "icon ni ni-hot-fill mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Sports",
        path: "/explore",
      },
      {
        id: 8,
        class: "text-cyan",
        icon: "icon ni ni-setting mb-3 mx-auto icon-circle icon-wbg icon-lg",
        title: "Utility",
        path: "/explore",
      },
    ],
  },
  funfactData: {
    funfactList: [
      {
        id: 1,
        icon: require("@/images/thumb/icon-employees.svg"),
        title: "Over 400+",
        subTitle: "Total Members",
      },
      {
        id: 2,
        icon: require("@/images/thumb/icon-users.svg"),
        title: "Over 40+",
        subTitle: "Total Countries",
      },
      {
        id: 3,
        icon: require("@/images/thumb/icon-nfts.svg"),
        title: "Over 1000+",
        subTitle: "Total NFTs",
      },
    ],
    funfactListTwo: [
      {
        id: 1,
        icon: require("@/images/thumb/icon-timeline.svg"),
        title: "2015",
        subTitle: "Founded",
      },
      {
        id: 2,
        icon: require("@/images/thumb/icon-employees.svg"),
        title: "68",
        subTitle: "Employees",
      },
      {
        id: 3,
        icon: require("@/images/thumb/icon-users.svg"),
        title: "400K+",
        subTitle: "Users",
      },
      {
        id: 4,
        icon: require("@/images/thumb/icon-collections.svg"),
        title: "1M",
        subTitle: "Collections",
      },
      {
        id: 5,
        icon: require("@/images/thumb/icon-nfts.svg"),
        title: "24M+",
        subTitle: "NFTs",
      },
      {
        id: 6,
        icon: require("@/images/thumb/icon-money.svg"),
        title: "$2B+",
        subTitle: "Volume",
      },
    ],
  },
  // Newsletter Data
  newsletterData: {
    title: "Join Our Newsletter",
  },
  // news data
  blogData: {
    title: "Check Out Our News",
    titleTwo: "You might have read about us in the news",
    content: "This is just a simple text made for this unique and awesome template, you can replace it with any text. It is a long established fact.",
    btnText: "View all articles",
    btnLink: "blog",
    blogList: [
      {
        id: 1,
        img: require("@/images/thumb/blog-img.jpg"),
        avatar: require("@/images/thumb/avatar-2.jpg"),
        title: "Enter Linda Dounia's Cyber Baat World",
        userName: "Alex Smith",
        desc: "Predictions for how secondary NFT sales will revolutionize industries.",
        date: "25 Apr 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 2,
        img: require("@/images/thumb/blog-img-2.jpg"),
        avatar: require("@/images/thumb/avatar-3.jpg"),
        title: "Artist Invite: Yung Jake and Lucien Smith",
        userName: "Kevin Martin",
        desc: "Art world friends and confidants share their thoughts on championing",
        date: "10 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 3,
        img: require("@/images/thumb/blog-img-3.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Visual storytelling with Alejandro Cartagena.",
        userName: "Kamran Ahmed",
        desc: "A photo-based interview with one of the leading photographers in NFTs.",
        date: "12 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 4,
        img: require("@/images/thumb/blog-img-4.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Announcing Our $100m Raise, Led By A1Studio",
        userName: "Alex Smith",
        desc: "Predictions for how secondary NFT sales will revolutionize industries.",
        date: "12 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
    ],
    blogListTwo: [
      {
        id: 1,
        img: require("@/images/thumb/blog-img.jpg"),
        avatar: require("@/images/thumb/avatar.jpg"),
        title: "Enter Linda Dounia's Cyber Baat World",
        userName: "Alex Smith",
        desc: "Predictions for how secondary NFT sales will revolutionize industries.",
        date: "25 Apr 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 2,
        img: require("@/images/thumb/blog-img-2.jpg"),
        avatar: require("@/images/thumb/avatar-2.jpg"),
        title: "Artist Invite: Yung Jake and Lucien Smith",
        userName: "Kevin Martin",
        desc: "Art world friends and confidants share their thoughts on championing",
        date: "10 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 3,
        img: require("@/images/thumb/blog-img-3.jpg"),
        avatar: require("@/images/thumb/avatar-3.jpg"),
        title: "Visual storytelling with Alejandro Cartagena.",
        userName: "Kamran Ahmed",
        desc: "You want to succeed, surround yourself with the right kind of people.",
        date: "12 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 4,
        img: require("@/images/thumb/blog-img-4.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Announcing Our $100m Raise, Led By A1Studio",
        userName: "Alex Smith",
        desc: "Predictions for how secondary NFT sales will revolutionize industries.",
        date: "12 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 5,
        img: require("@/images/thumb/blog-img-5.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "The Biggest Drop In Times Square Since New Year",
        userName: "Kevin Martin",
        desc: "Art world friends and confidants share their thoughts on championing",
        date: "12 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
      {
        id: 6,
        img: require("@/images/thumb/blog-img-6.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Daz 3d, The Digitals And Ground breaking",
        userName: "David Martin",
        desc: "You want to succeed, surround yourself with the right kind of people.",
        date: "12 May 2022",
        numberText: "25",
        numberTextTwo: "38",
        btnLink: "/blog-detail",
      },
    ],
    blogListThree: [
      {
        id: 1,
        img: require("@/images/thumb/blog-img.jpg"),
        avatar: require("@/images/thumb/avatar.jpg"),
        title: "Enter Linda Dounia's Cyber Baat World",
        userName: "Alex Smith",
        desc: "Predictions for how secondary NFT sales will revolutionize industries.",
        date: "25 Apr 2022",
        numberText: "25",
        numberTextTwo: "38",
      },
      {
        id: 2,
        img: require("@/images/thumb/blog-img-2.jpg"),
        avatar: require("@/images/thumb/avatar-2.jpg"),
        title: "Artist Invite: Yung Jake and Lucien Smith",
        userName: "Kevin Martin",
        desc: "Art world friends and confidants share their thoughts on championing",
        date: "10 May 2022",
        numberText: "26",
        numberTextTwo: "39",
      },
      {
        id: 3,
        img: require("@/images/thumb/blog-img-3.jpg"),
        avatar: require("@/images/thumb/avatar-3.jpg"),
        title: "Visual storytelling with Alejandro Cartagena.",
        userName: "Kamran Ahmed",
        desc: "You want to succeed, surround yourself with the right kind of people.",
        date: "12 May 2022",
        numberText: "27",
        numberTextTwo: "12",
      },
      {
        id: 4,
        img: require("@/images/thumb/blog-img-4.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Announcing Our $100m Raise, Led By A1Studio",
        userName: "Alex Smith",
        desc: "Predictions for how secondary NFT sales will revolutionize industries.",
        date: "14 May 2022",
        numberText: "13",
        numberTextTwo: "23",
      },
      {
        id: 5,
        img: require("@/images/thumb/blog-img-5.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "The Biggest Drop In Times Square Since New Year",
        userName: "Kevin Martin",
        desc: "Art world friends and confidants share their thoughts on championing",
        date: "16 May 2022",
        numberText: "14",
        numberTextTwo: "14",
      },
      {
        id: 6,
        img: require("@/images/thumb/blog-img-6.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Daz 3d, The Digitals And Ground breaking",
        userName: "David Martin",
        desc: "Nora Khan gets experimental with artists.",
        date: "19 May 2022",
        numberText: "11",
        numberTextTwo: "23",
      },
      {
        id: 7,
        img: require("@/images/thumb/blog-img-6.jpg"),
        avatar: require("@/images/thumb/avatar-3.jpg"),
        title: "Daz 3d, The Digitals And Ground breaking",
        userName: "Kamran Ahmed",
        desc: "Sarah Meyohas on bringing femininity into crypto.",
        date: "20 May 2022",
        numberText: "12",
        numberTextTwo: "34",
      },
      {
        id: 8,
        img: require("@/images/thumb/blog-img-5.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "The Digitals And Ground breaking",
        userName: "Smith Martin",
        desc: "David Horvitz on a baby born in the back of an Uber.",
        date: "21 May 2022",
        numberText: "34",
        numberTextTwo: "12",
      },
      {
        id: 9,
        img: require("@/images/thumb/blog-img-4.jpg"),
        avatar: require("@/images/thumb/avatar.jpg"),
        title: "Brian Calvin on his imaginary portraits.",
        userName: "Alex Smith",
        desc: "Visual storytelling with Alejandro Cartagena.",
        date: "22 May 2022",
        numberText: "22",
        numberTextTwo: "39",
      },
      {
        id: 10,
        img: require("@/images/thumb/blog-img-3.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Everything you need to know about DAOs.",
        userName: "David Martin",
        desc: "Tyler Givens on making fantasies a reality.",
        date: "23 May 2022",
        numberText: "27",
        numberTextTwo: "36",
      },
      {
        id: 11,
        img: require("@/images/thumb/blog-img-2.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Exonemo on communicating love and hate for NFTs. ",
        userName: "Alex Martin",
        desc: "Auriea Harvey Splits with bitforms gallery.",
        date: "24 May 2022",
        numberText: "25",
        numberTextTwo: "34",
      },
      {
        id: 12,
        img: require("@/images/thumb/blog-img.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Miya Folick on becoming very good at living.",
        userName: "David Martin",
        desc: "Auriea Harvey Splits with bitforms gallery.",
        date: "25 May 2022",
        numberText: "22",
        numberTextTwo: "31",
      },
      {
        id: 13,
        img: require("@/images/thumb/blog-img-2.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Reuben Wu is photographing the future. ",
        userName: "David Martin",
        desc: "Idil Dursun is constructing new worlds.",
        date: "26 May 2022",
        numberText: "23",
        numberTextTwo: "34",
      },
      {
        id: 14,
        img: require("@/images/thumb/blog-img-3.jpg"),
        avatar: require("@/images/thumb/avatar.jpg"),
        title: "Jon Rafman on standing in an open field.",
        userName: "Alex David",
        desc: "Artist Invite: Archan Nair & Iannocent",
        date: "27 May 2022",
        numberText: "22",
        numberTextTwo: "18",
      },
      {
        id: 15,
        img: require("@/images/thumb/blog-img.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Daylen Seu on tapping into dreams and nightmares. ",
        userName: "David Martin",
        desc: "Paper Rad on setting the precedent for Internet culture.",
        date: "28 May 2022",
        numberText: "23",
        numberTextTwo: "38",
      },
      {
        id: 16,
        img: require("@/images/thumb/blog-img-5.jpg"),
        avatar: require("@/images/thumb/avatar-2.jpg"),
        title: "The Digitals And Ground breaking Daz 3d",
        userName: "Kamran Ahamed",
        desc: "Chris Torres on building the Meme Economy.",
        date: "29 May 2022",
        numberText: "25",
        numberTextTwo: "34",
      },
      {
        id: 17,
        img: require("@/images/thumb/blog-img-6.jpg"),
        avatar: require("@/images/thumb/avatar-5.jpg"),
        title: "Artist Invite: Yung Jake and Lucien Smith",
        userName: "David Martin",
        desc: "Chris Torres on building the Meme Economy.",
        date: "30 May 2022",
        numberText: "27",
        numberTextTwo: "12",
      },
      {
        id: 18,
        img: require("@/images/thumb/blog-img-4.jpg"),
        avatar: require("@/images/thumb/avatar-4.jpg"),
        title: "Enter Linda Dounias Cyber Baat World",
        userName: "Alex Smith",
        desc: "Diana Sinclair on curating The Digital Diaspora.",
        date: "12 Jun 2022",
        numberText: "28",
        numberTextTwo: "41",
      },
    ],
  },
  blogDetail: {
    img: require("@/images/thumb/blog-img.jpg"),
    content:
      "Predictions for how secondary NFT sales will revolutionize creative industries. Elementum lacus, tempus aliquam turpis diam amet leo enim. Nisi enim condimentum tincidunt ornare nam adipiscing. Volutpat lacus, est hendrerit elit sed interdum. amet leo enim.",
    contentTwo:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elementum lacus, tempus aliquam turpis diam amet leo enim. Nisi enim condimentum tincidunt ornare nam adipiscing. Volutpat lacus, est hendrerit elit sed interdum. amet leo enim.",
    quoteText:
      "Design can be art. Design can be simple. That’s why it’s so complicated. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    contentThree:
      "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. There live the blind texts.",
    contentFour:
      "Astro ipsum dolor sit amet, consectetur adipiscing elit. Elementum lacus, tempus aliquam turpis diam amet leo enim. Nisi enim condimentum tincidunt ornare nam adipiscing. Volutpat lacus, est hendrerit elit sed interdum. amet leo enim.",
    title: "Submit Your Work",
    contentFive:
      "Quis sunt quis do laboris eiusmod in sint dolore sit pariatur consequat commodo aliqua nulla ad dolor aliquip incididunt voluptate est aliquip adipisicing ea cupidatat nostrud incididunt aliquip dolore. Sed minim nisi duis laborum est labore nisi amet elit adipisicing proident do consectetur dolor labore sit nisi ad proident.",
    imgList: [require("@/images/thumb/blog-img.jpg"), require("@/images/thumb/blog-img-2.jpg")],
    tags: [
      {
        id: 1,
        title: "Vision",
        path: "",
      },
      {
        id: 2,
        title: "Music",
        path: "",
      },
    ],
    shares: [
      {
        id: 1,
        icon: "ni-facebook-f",
        path: "",
      },
      {
        id: 2,
        icon: "ni-twitter",
        path: "",
      },
    ],
  },
  // cta data
  ctaData: {
    title: "Tyler Givens on making  fantasies a reality",
    content: "I must explain to you how all this mistaken idea of the denouncing and praising pain was born and I will give you complete.",
    btnText: "Explore EnftyMart",
    btnLink: "explore",
  },
  ctaDataTwo: {
    title: "Interested in joining us?",
    content: "Hop aboard and view our open positions",
    btnText: "See open roles",
    btnLink: "contact",
  },
  // author data
  authorPublicData: {
    title: "French Montana",
    userName: "@frenchmontana",
    btnText: "Follow",
    btnLink: "",
    img: require("@/images/thumb/avatar-8.jpg"),
    coverImg: require("@/images/thumb/bread-bg-2.jpg"),
  },
  authorSidebarData: {
    authorTabNav: [
      {
        id: 1,
        isActive: "active",
        title: "On Sale",
        slug: "on-sale-tab",
        bsTarget: "#on-sale",
      },
      {
        id: 2,
        title: "Owned",
        slug: "owned-tab",
        bsTarget: "#owned",
      },
      {
        id: 3,
        title: "Created",
        slug: "created-tab",
        bsTarget: "#created",
      },
    ],
    sidebarWidget: {
      title: "关于我",
      content: "我做艺术的目的很简单，就是给你一些好看的东西，让你看几秒钟.",
      followingNum: 30,
      followingText: "Following",
      followerNum: 371,
      followerText: "Followers",
      followText: "Followed by",
      followersAvatar: [
        {
          id: 1,
          avatar: require("@/images/thumb/avatar.jpg"),
          path: "",
        },
        {
          id: 2,
          avatar: require("@/images/thumb/avatar-2.jpg"),
          path: "",
        },
        {
          id: 3,
          avatar: require("@/images/thumb/avatar-3.jpg"),
          path: "",
        },
        {
          id: 4,
          avatar: require("@/images/thumb/avatar-4.jpg"),
          path: "",
        },
        {
          id: 5,
          avatar: require("@/images/thumb/avatar-5.jpg"),
          path: "",
        },
      ],
      btnText: "View All",
    },
    sidebarWidgetTwo: {
      title: "联系方式",
      links: [
        {
          class: "ni-globe",
          title: "",
          path: "",
        },
        {
          class: "ni-facebook-f",
          title: "Facebook",
          path: "",
        },
        {
          class: "ni-twitter",
          title: "Twitter",
          path: "",
        },
        {
          class: "ni-instagram",
          title: "Instagram",
          path: "",
        },
      ],
    },
    sidebarWidgetThree: {
      title: "加入时间",
      date: "Septermber 13, 2021",
    },
  },
  // author data
  authorSidebarDataTwo: {
    sidebarWidget: {
      content: "I make art with the simple goal of giving you something pleasing to look at for a few seconds.",
      followingNum: 130,
      followingText: "Following",
      followerNum: 271,
      followerText: "Followers",
      followText: "Followed by",
      followersAvatar: [
        {
          id: 1,
          avatar: require("@/images/thumb/avatar.jpg"),
          path: "",
        },
        {
          id: 2,
          avatar: require("@/images/thumb/avatar-2.jpg"),
          path: "",
        },
        {
          id: 3,
          avatar: require("@/images/thumb/avatar-3.jpg"),
          path: "",
        },
        {
          id: 4,
          avatar: require("@/images/thumb/avatar-4.jpg"),
          path: "",
        },
        {
          id: 5,
          avatar: require("@/images/thumb/avatar-5.jpg"),
          path: "",
        },
      ],
    },
    sidebarWidgetTwo: {
      links: [
        {
          class: "ni-globe",
          title: "微信",
          path: "",
        },
        {
          class: "ni-facebook-f",
          title: "QQ",
          path: "",
        }
      ],
    },
    sidebarWidgetThree: {
      date: "Septermber 13, 2021",
    },
  },
  // author personal data
  authorPersonalData: {
    title: "YOOCH",
    userName: "@kamran_76",
    btnText: "Edit Profile",
    img: require("@/images/thumb/avatar-9.jpg"),
    coverImg: require("@/images/thumb/bread-bg-2.jpg"),
    btnLink: "/account",
    btnTextTwo: "Profile",
    btnLinkTwo: "/profile",
  },
  // author nav
  authorNav: [
    {
      id: 1,
      title: "简介",
      path: "profile",
      icon: "ni-user",
    },
    {
      id: 2,
      title: "仪表盘",
      path: "offers",
      icon: "ni-dashboard",
    },
    {
      id: 3,
      title: "帐户设置",
      path: "account",
      icon: "ni-setting",
    },
    {
      id: 4,
      title: "帮助中心",
      path: "contact",
      icon: "ni-question-alt",
    },
  ],
  // offer sidebar data
  offerSidebarData: {
    title: "Enfty Dashboard",
    navList: [
      {
        id: 1,
        class: "active",
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  activitySidebarData: {
    title: "Activity",
    navList: [
      {
        id: 1,
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        class: "active",
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  salePurchaseSidebarData: {
    title: "Sales / Purchase",
    navList: [
      {
        id: 1,
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        class: "active",
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  transactionsSidebarData: {
    title: "Transactions",
    navList: [
      {
        id: 1,
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        class: "active",
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  displaySidebarData: {
    title: "Display Enfties",
    navList: [
      {
        id: 1,
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        class: "active",
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  redeemSidebarData: {
    title: "Redeem Enfties",
    navList: [
      {
        id: 1,
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        class: "active",
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  depositSidebarData: {
    title: "Deposit Enfties",
    navList: [
      {
        id: 1,
        icon: "ni-gift",
        title: "My Offers",
        path: "offers",
      },
      {
        id: 2,
        icon: "ni-file-text",
        title: "Activity",
        path: "activity-v2",
      },
      {
        id: 3,
        icon: "ni-money",
        title: "Sales / Purchase",
        path: "purchases-sales",
      },
      {
        id: 4,
        icon: "ni-exchange",
        title: "Transactions",
        path: "transactions",
      },
      {
        id: 5,
        icon: "ni-camera",
        title: "Display",
        path: "display",
      },
      {
        id: 6,
        icon: "ni-puzzle",
        title: "Redeem",
        path: "redeem",
      },
      {
        id: 7,
        class: "active",
        icon: "ni-download-cloud",
        title: "Deposit Enfties",
        path: "deposit-enfties",
      },
    ],
  },
  // account sidebar
  accountSidebarData: {
    title: "Account Settings",
    navList: [
      {
        id: 1,
        class: "active",
        icon: "ni-edit",
        title: "Edit Profile",
        path: "account",
      },
      {
        id: 2,
        icon: "ni-money",
        title: "Payment Methods",
        path: "payment-methods",
      },
      {
        id: 3,
        icon: "ni-user",
        title: "Seller Settings",
        path: "seller-settings",
      },
      {
        id: 4,
        icon: "ni-bell",
        title: "Notifications",
        path: "notifications",
      },
      {
        id: 5,
        icon: "ni-lock",
        title: "Security",
        path: "security",
      },
    ],
  },
  // payment method sidebar
  paymentMethodSidebarData: {
    title: "Payment Methods",
    navList: [
      {
        id: 1,
        icon: "ni-edit",
        title: "Edit Profile",
        path: "account",
      },
      {
        id: 2,
        class: "active",
        icon: "ni-money",
        title: "Payment Methods",
        path: "payment-methods",
      },
      {
        id: 3,
        icon: "ni-user",
        title: "Seller Settings",
        path: "seller-settings",
      },
      {
        id: 4,
        icon: "ni-bell",
        title: "Notifications",
        path: "notifications",
      },
      {
        id: 5,
        icon: "ni-lock",
        title: "Security",
        path: "security",
      },
    ],
  },
  // seller setting sidebar
  sellerSettingSidebarData: {
    title: "Seller Settings",
    navList: [
      {
        id: 1,
        icon: "ni-edit",
        title: "Edit Profile",
        path: "account",
      },
      {
        id: 2,
        icon: "ni-money",
        title: "Payment Methods",
        path: "payment-methods",
      },
      {
        id: 3,
        class: "active",
        icon: "ni-user",
        title: "Seller Settings",
        path: "seller-settings",
      },
      {
        id: 4,
        icon: "ni-bell",
        title: "Notifications",
        path: "notifications",
      },
      {
        id: 5,
        icon: "ni-lock",
        title: "Security",
        path: "security",
      },
    ],
  },
  // notification sidebar
  notificationSidebarData: {
    title: "Notifications",
    navList: [
      {
        id: 1,
        icon: "ni-edit",
        title: "Edit Profile",
        path: "account",
      },
      {
        id: 2,
        icon: "ni-money",
        title: "Payment Methods",
        path: "payment-methods",
      },
      {
        id: 3,
        icon: "ni-user",
        title: "Seller Settings",
        path: "seller-settings",
      },
      {
        id: 4,
        class: "active",
        icon: "ni-bell",
        title: "Notifications",
        path: "notifications",
      },
      {
        id: 5,
        icon: "ni-lock",
        title: "Security",
        path: "security",
      },
    ],
  },
  // Security sidebar
  securitySidebarData: {
    title: "Security",
    navList: [
      {
        id: 1,
        icon: "ni-edit",
        title: "Edit Profile",
        path: "account",
      },
      {
        id: 2,
        icon: "ni-money",
        title: "Payment Methods",
        path: "payment-methods",
      },
      {
        id: 3,
        icon: "ni-user",
        title: "Seller Settings",
        path: "seller-settings",
      },
      {
        id: 4,
        icon: "ni-bell",
        title: "Notifications",
        path: "notifications",
      },
      {
        id: 5,
        class: "active",
        icon: "ni-lock",
        title: "Security",
        path: "security",
      },
    ],
  },
  sellerSettingData: {
    title: "Seller Settings",
    content: 'Current <strong>Authorized Seller </strong> Status: <strong class="text-warning">Restricted</strong>',
    contentTwo: "You must be an authorized seller in order to sell Enfties on EnftyMart. To authorize your account for sales, please sign in to Stripe Connect.",
    contentThree: "Even if you can't become an authorized seller, you can still use the rest of EnftyMart: buy & collect Enfties, gift them to other users, or withdraw them to an external wallet.",
    btnText: "Authorize Seller Account",
    contentFour: 'If your country does not appear, it may not be supported by Stripe Connect. Please contact <a href="contact" class="btn-link">customer support</a>',
  },
  // security data
  securityData: {
    title: "Security",
    titleTwo: "How Does it Work?",
    content:
      'EnftyMart uses <a href="#" class="btn-link text-primary">Authy</a> as a 2fa provider. On enrollment in 2fa, we will send you a link to download authy and a code to confirm your phone number. You will then recieve 2fa requests through this app.',
    logos: [
      {
        id: 1,
        path: "",
        img: require("@/images/thumb/google-play.png"),
      },
      {
        id: 2,
        path: "",
        img: require("@/images/thumb/app-store.png"),
      },
    ],
    contentTwo:
      "In cases where authy cannot be installed, sms messaging can be used for 2fa. <strong>This is a last case scenario </strong> as sms provides a <strong>less secure</strong> experience and will prevent you from enabling advanced 2fa settings within the site.",
    labelText: "Input your phone number below to enroll",
    btnText: "Enroll Number",
  },
  // offer data
  offerData: {
    mainTitle: "Enfty Dashboard",
    title: "Your Received Offers:",
    titleTwo: "Offers You've Made:",
    subTitle: "Showing 1 to 6 of 30 entries",
    subTitleTwo: "Showing 1 to 6 of 10 entries",
    alertText: 'In order to sell NFTs on EnftyMart, you must <a href="seller-settings" class="btn-link">become an authorized seller.</a> It only takes a few minutes!',
    tabNav: [
      {
        id: 1,
        isActive: "active",
        title: "Received Offers (30)",
        slug: "offers-receive-tab",
        bsTarget: "#offers-receive",
      },
      {
        id: 2,
        title: "Offers Made (10)",
        slug: "offers-made-tab",
        bsTarget: "#offers-made",
      },
    ],
    receiveItems: [
      {
        id: 1,
        timeText: "Offer received 13m ago",
        title: "Eternal Zen",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$1,800.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        btns: [
          {
            id: 1,
            title: "Accept Offer",
            btnClass: "text-success",
            path: "#",
          },
          {
            id: 2,
            title: "Cancel Offer",
            btnClass: "text-danger",
            path: "#",
          },
        ],
      },
      {
        id: 2,
        timeText: "Offer received 17m ago",
        title: "Somnium Rubram",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-2.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$2,300.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        btns: [
          {
            id: 1,
            title: "Accept Offer",
            btnClass: "text-success",
            path: "#",
          },
          {
            id: 2,
            title: "Cancel Offer",
            btnClass: "text-danger",
            path: "#",
          },
        ],
      },
      {
        id: 3,
        timeText: "Offer received 1h ago",
        title: "Dance or Die",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-3.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$3,200.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        btns: [
          {
            id: 1,
            title: "Accept Offer",
            btnClass: "text-success",
            path: "#",
          },
          {
            id: 2,
            title: "Cancel Offer",
            btnClass: "text-danger",
            path: "#",
          },
        ],
      },
      {
        id: 4,
        timeText: "Offer received 1 week ago",
        title: "Genesis.001",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-4.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$1,800.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        btns: [
          {
            id: 1,
            title: "Accept Offer",
            btnClass: "text-success",
            path: "#",
          },
          {
            id: 2,
            title: "Cancel Offer",
            btnClass: "text-danger",
            path: "#",
          },
        ],
      },
      {
        id: 5,
        timeText: "Offer received 9h 30m ago",
        title: "Karma Chameleon",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-5.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$1,800.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        btns: [
          {
            id: 1,
            title: "Accept Offer",
            btnClass: "text-success",
            path: "#",
          },
          {
            id: 2,
            title: "Cancel Offer",
            btnClass: "text-danger",
            path: "#",
          },
        ],
      },
      {
        id: 6,
        timeText: "Offer received 1 week ago",
        title: "Detritus #17",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-6.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$2,300.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        btns: [
          {
            id: 1,
            title: "Accept Offer",
            btnClass: "text-success",
            path: "#",
          },
          {
            id: 2,
            title: "Cancel Offer",
            btnClass: "text-danger",
            path: "#",
          },
        ],
      },
    ],
    madeItems: [
      {
        id: 1,
        timeText: "Offer received 13m ago",
        title: "Eternal Zen",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$1,800.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        badgeClass: "bg-info",
        badgeText: "Pending",
        btnText: "Cancel Offer",
      },
      {
        id: 2,
        timeText: "Offer received 17m ago",
        title: "Somnium Rubram",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-2.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$2,300.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        badgeClass: "bg-info",
        badgeText: "Pending",
        btnText: "Cancel Offer",
      },
      {
        id: 3,
        timeText: "Offer received 1h ago",
        title: "Dance or Die",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-3.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$3,200.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        badgeClass: "bg-danger",
        badgeText: "Declined",
      },
      {
        id: 4,
        timeText: "Offer received 1 week ago",
        title: "Genesis.001",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-4.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$1,800.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        badgeClass: "bg-danger",
        badgeText: "Declined",
      },
      {
        id: 5,
        timeText: "Offer received 9h 30m ago",
        title: "Karma Chameleon",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-5.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$1,800.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        badgeClass: "bg-info",
        badgeText: "Pending",
        btnText: "Cancel Offer",
      },
      {
        id: 6,
        timeText: "Offer received 1 week ago",
        title: "Detritus #17",
        path: "/product-details-v1-1",
        img: require("@/images/thumb/small-img-6.jpg"),
        addressText: "Contact Address",
        addressTextTwo: "08 W 36th St, New York, NY 10001",
        actionList: [
          {
            id: 1,
            title: "Get Offer",
            subTitle: "$2,300.00",
          },
          {
            id: 2,
            title: "Payment Methods",
            subTitle: "Visa ending in 9720",
          },
        ],
        badgeClass: "bg-info",
        badgeText: "Pending",
        btnText: "Cancel Offer",
      },
    ],
  },
  // user activity data
  userActivityTabNav: [
    {
      id: 1,
      isActive: "active",
      title: "All",
      slug: "all-tab",
      bsTarget: "#all",
    },
    {
      id: 2,
      title: "Following",
      slug: "following-tab",
      bsTarget: "#following",
    },
    {
      id: 3,
      title: "Bidding",
      slug: "bidding-tab",
      bsTarget: "#bidding",
    },
    {
      id: 4,
      title: "Sales",
      slug: "sales-tab",
      bsTarget: "#sales",
    },
  ],
  userActivityItems: {
    mainTitle: "Activity",
    allData: [
      {
        id: 1,
        title: "Monica Lucas",
        subTitle: "Started following",
        author: "Gayle Hicks",
        path: "/author",
        img: require("@/images/thumb/avatar.jpg"),
        timeText: "10/07/2021, 12:40",
      },
      {
        id: 2,
        title: "Deep Sea Phantasy",
        subTitle: "Bid placed by",
        meta: "for",
        price: "0.001",
        author: "Stacy Long",
        path: "/author",
        img: require("@/images/thumb/avatar-2.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 3,
        title: "Cute Astronout",
        subTitle: "Purchased by",
        meta: "for",
        price: "0.145",
        author: "Nicholas Daniels",
        path: "/author",
        img: require("@/images/thumb/avatar-3.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 4,
        title: "Mamie Barnett",
        subTitle: "Started following",
        author: "Nicholas Daniels",
        path: "/author",
        img: require("@/images/thumb/avatar-4.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 5,
        title: "Alex Smith",
        subTitle: "Started following",
        author: "Kevin Martin",
        path: "/author",
        img: require("@/images/thumb/avatar-5.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 6,
        title: "Jhonathan Doe",
        subTitle: "Bid placed by",
        author: "Evan You",
        meta: "for",
        price: "0.013",
        path: "/author",
        img: require("@/images/thumb/avatar-6.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 7,
        title: "Jhon Abraham",
        subTitle: "Purchased by",
        meta: "for",
        price: "0.212",
        author: "David Hardson",
        path: "/author",
        img: require("@/images/thumb/avatar-7.jpg"),
        timeText: "12/05/2021, 12:30",
      },
    ],
    followingData: [
      {
        id: 1,
        title: "Monica Lucas",
        author: "Gayle Hicks",
        path: "/author",
        img: require("@/images/thumb/avatar-8.jpg"),
        timeText: "10/07/2021, 12:40",
      },
      {
        id: 2,
        title: "Mamie Barnett",
        author: "Nicholas Daniels",
        path: "/author",
        img: require("@/images/thumb/avatar-9.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 3,
        title: "Alex Smith",
        author: "Kevin Martin",
        path: "/author",
        img: require("@/images/thumb/avatar-10.jpg"),
        timeText: "12/05/2021, 11:34",
      },
    ],
    biddingData: [
      {
        id: 1,
        title: "Deep Sea Phantasy",
        author: "Stacy Long",
        meta: "for",
        price: "0.212",
        path: "/author",
        img: require("@/images/thumb/avatar-2.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 2,
        title: "Jhonathan Doe",
        author: "Evan You",
        meta: "for",
        price: "0.212",
        path: "/author",
        img: require("@/images/thumb/avatar-6.jpg"),
        timeText: "12/05/2021, 11:34",
      },
    ],
    salesData: [
      {
        id: 1,
        title: "Cute Astronout",
        author: "Nicholas Daniels",
        meta: "for",
        price: "0.212",
        path: "/author",
        img: require("@/images/thumb/avatar-3.jpg"),
        timeText: "12/05/2021, 11:34",
      },
      {
        id: 2,
        title: "Jhon Abraham",
        author: "David Hardson",
        meta: "for",
        price: "0.212",
        path: "/author",
        img: require("@/images/thumb/avatar-7.jpg"),
        timeText: "12/05/2021, 12:30",
      },
    ],
  },
  // purchases and sale tab nav
  purchaseAndSaleTabNav: [
    {
      id: 1,
      isActive: "active",
      title: "Purchases",
      slug: "purchases-tab",
      bsTarget: "#purchases",
    },
    {
      id: 2,
      title: "Sales",
      slug: "sales-tab",
      bsTarget: "#sales",
    },
  ],
  // purchases and sale tab nav
  purchaseAndSaleTabNavMobile: [
    {
      id: 1,
      isActive: "active",
      title: "Purchases",
      slug: "purchases-tab-mobile",
      bsTarget: "#purchases-mobile",
    },
    {
      id: 2,
      title: "Sales",
      slug: "sales-tab-mobile",
      bsTarget: "#sales-mobile",
    },
  ],
  // purchases and sale data
  purchaseAndSaleData: {
    mainTitle: "Sales & Purchase",
    purchaseData: [
      {
        id: 1,
        title: "Serpent #76/140",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 2,
        title: " Afterburn",
        author: "Kamran",
        authorLink: "/author",
        price: "20.00",
        dateText: "4d ago",
      },
      {
        id: 3,
        title: " Dance or Die",
        author: "Jhon",
        authorLink: "/author",
        price: "50.00",
        dateText: "3d ago",
      },
      {
        id: 4,
        title: "Green Parrot Island",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 5,
        title: "Lavish",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 6,
        title: "Karma Chameleon",
        author: "Alex",
        authorLink: "/author",
        price: "25.00",
        dateText: "4d ago",
      },
      {
        id: 7,
        title: "Le Anime",
        author: "Alex",
        authorLink: "/author",
        price: "20.00",
        dateText: "4d ago",
      },
      {
        id: 8,
        title: "Lady Robot #62",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "3d ago",
      },
      {
        id: 9,
        title: "Creature #8477",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "2d ago",
      },
      {
        id: 10,
        title: "Gold #422/477",
        author: "Alex",
        authorLink: "/author",
        price: "12.00",
        dateText: "1d ago",
      },
    ],
    salesData: [
      {
        id: 1,
        title: "Lady Robot #62",
        author: "David",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 2,
        title: "Creature #8477",
        author: "Robi",
        authorLink: "/author",
        price: "30.00",
        dateText: "4d ago",
      },
      {
        id: 3,
        title: "Gold #422/477",
        author: "Jared Liner",
        authorLink: "/author",
        price: "50.00",
        dateText: "4d ago",
      },
      {
        id: 4,
        title: "Serpent #76/140 ",
        author: "Antonio",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 5,
        title: "Afterburn",
        author: "Jhon",
        authorLink: "/author",
        price: "30.00",
        dateText: "4d ago",
      },
      {
        id: 6,
        title: "Dance or Die",
        author: "Kevin Martin",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 7,
        title: "Green Parrot Island",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 8,
        title: "Lavish",
        author: "Alex",
        authorLink: "/author",
        price: "250.00",
        dateText: "4d ago",
      },
      {
        id: 9,
        title: "Karma Chameleon",
        author: "Kamran",
        authorLink: "/author",
        price: "25.00",
        dateText: "4d ago",
      },
      {
        id: 10,
        title: "Le Anime",
        author: "Alex",
        authorLink: "/author",
        price: "22.00",
        dateText: "4d ago",
      },
    ],
  },
  // transactions data
  transactionsData: {
    mainTitle: "Transactions",
    transactionsTableHead: ["#", "Customer", "Issue Date", "Total", "Type", "Status", "Action"],
    transactionsTableBody: [
      {
        id: 4947,
        title: "Patternlicious",
        timeText: "10-05-2019",
        price: "$599.00",
        img: require("@/images/brand/visa.png"),
        badgeText: "Approved",
        badgeClass: "bg-success",
      },
      {
        id: 4904,
        title: "Alex Smith",
        timeText: "10-05-2019",
        price: "$599.00",
        img: require("@/images/brand/paypal.png"),
        badgeText: "Approved",
        badgeClass: "bg-success",
      },
      {
        id: 4840,
        title: "Alex Smith",
        timeText: "10-05-2019",
        price: "$99.00",
        img: require("@/images/brand/a-express.png"),
        badgeText: "Declined",
        badgeClass: "bg-danger",
      },
      {
        id: 4740,
        title: "Patternlicious",
        timeText: "10-05-2019",
        price: "$599.00",
        img: require("@/images/brand/visa.png"),
        badgeText: "Approved",
        badgeClass: "bg-success",
      },
      {
        id: 4444,
        title: "Patternlicious",
        timeText: "10-05-2019",
        price: "$599.00",
        img: require("@/images/brand/paypal.png"),
        badgeText: "Approved",
        badgeClass: "bg-success",
      },
      {
        id: 4144,
        title: "Patternlicious",
        timeText: "10-05-2019",
        price: "$599.00",
        img: require("@/images/brand/a-express.png"),
        badgeText: "Declined",
        badgeClass: "bg-danger",
      },
    ],
  },
  // edit profile data
  editProfileData: {
    title: "Account Settings",
    editProfileTabNav: [
      {
        id: 1,
        isActive: "active",
        title: "Edit Info",
        slug: "account-information-tab",
        bsTarget: "#account-information",
      },
      {
        id: 2,
        title: "Password",
        slug: "change-password-tab",
        bsTarget: "#change-password",
      },
      {
        id: 3,
        title: "Verify Profile",
        slug: "validate-profile-tab",
        bsTarget: "#validate-profile",
      },
    ],
    // edit profile tab mobile
    editProfileTabNavMobile: [
      {
        id: 1,
        isActive: "active",
        title: "Account Information",
        slug: "account-information-tab-mobile",
        bsTarget: "#account-information-mobile",
      },
      {
        id: 2,
        title: "Change Password",
        slug: "change-password-tab-mobile",
        bsTarget: "#change-password-mobile",
      },
      {
        id: 3,
        title: "Validate Profile",
        slug: "validate-profile-tab-mobile",
        bsTarget: "#validate-profile-mobile",
      },
    ],
  },
  // payment method data
  paymentMethodData: {
    title: "Payment Methods",
    paymentMethodTabNav: [
      {
        id: 1,
        isActive: "active",
        title: "Balances",
        slug: "balances-tab",
        bsTarget: "#balances",
      },
      {
        id: 2,
        title: "Credit Cards",
        slug: "credit-cards-tab",
        bsTarget: "#credit-cards",
      },
      {
        id: 3,
        title: "Prepaid ETH",
        slug: "prepaid-eth-tab",
        bsTarget: "#prepaid-eth",
      },
    ],
    // edit profile tab mobile
    paymentMethodTabNavMobile: [
      {
        id: 1,
        isActive: "active",
        title: "Balances",
        slug: "balances-tab-mobile",
        bsTarget: "#balances-mobile",
      },
      {
        id: 2,
        title: "Credit Cards",
        slug: "credit-cards-tab-mobile",
        bsTarget: "#credit-cards-mobile",
      },
      {
        id: 3,
        title: "Prepaid ETH",
        slug: "prepaid-eth-tab-mobile",
        bsTarget: "#prepaid-eth-mobile",
      },
    ],
  },

  // notification data
  notificationData: {
    title: "Notifications",
    notificationTabNav: [
      {
        id: 1,
        isActive: "active",
        title: "Email Alerts",
        slug: "email-alerts-tab",
        bsTarget: "#email-alerts",
      },
      {
        id: 2,
        title: "Price Alerts",
        slug: "price-alerts-tab",
        bsTarget: "#price-alerts",
      },
    ],
    // notification tab mobile
    notificationTabNavMobile: [
      {
        id: 1,
        isActive: "active",
        title: "Email Alerts",
        slug: "email-alerts-tab-mobile",
        bsTarget: "#email-alerts-mobile",
      },
      {
        id: 2,
        title: "Price Alerts",
        slug: "price-alerts-tab-mobile",
        bsTarget: "#price-alerts-mobile",
      },
    ],
  },
  // credit card data
  creditCardList: [
    {
      id: 1,
      title: "Visa ending in 8203",
      timeText: "08/11/2022",
      img: require("@/images/thumb/visa.png"),
      titleTwo: "Billing address",
      addressText: "123 Fake Sreet, 3rd Floor, San Francisco, California, 94105, United States",
    },
    {
      id: 2,
      title: "Mastercard ending in 4720",
      timeText: "02/9/2022",
      img: require("@/images/thumb/master-card.png"),
      titleTwo: "Billing address",
      addressText: "240 Descano Drive, Level 5, San Francisco, California, 34105, United States",
    },
  ],
  // credit card data
  creditCardData: {
    alertText: "Using a Capital One card may lead to issues completing purchases. Please consider using a different card until further notice.",
    title: "Your Saved Credit Cards:",
    content: "You created new card. Transactions status i 'Authorized'",
    btnText: "Add New Card",
  },
  // create data
  createData: {
    btnText: "Go Back",
    path: "/",
    title: "Create collectible",
    content: "Choose <strong>“Single”</strong> if you want your collectible to be one of a kind or <strong>“Multiple”</strong> if you want to sell one collectible multiple times",
    cards: [
      {
        id: 1,
        title: "Single",
        img: require("@/images/thumb/single-mobile.png"),
        path: "create-single",
      },
      {
        id: 1,
        title: "Mutiple",
        img: require("@/images/thumb/multiple-mobile.png"),
        path: "create-multiple",
      },
    ],
    contentTwo: "We do not own your private keys and cannot access your funds without your confirmation",
  },
  // create
  // eslint-disable-next-line no-dupe-keys
  createData: {
    btnText: "Manage collectible type",
    // path: "/create",
    title: "Create single collectible",
  },
  // select method tab nav
  selectMethodTabNav: [
    {
      id: 1,
      isActive: "active",
      title: "Fixed Price",
      slug: "fixed-price-tab",
      bsTarget: "#fixed-price",
      icon: "ni-tags",
    },
    {
      id: 2,
      title: "Timed Auction",
      slug: "timed-auction-tab",
      bsTarget: "#timed-auction",
      icon: "ni-clock",
    },
    {
      id: 3,
      title: "Open for bids",
      slug: "open-for-bids-tab",
      bsTarget: "#open-for-bids",
      icon: "ni-file",
    },
  ],
  // select method tab nav
  selectMethodTabNavTwo: [
    {
      id: 1,
      isActive: "active",
      title: "Fixed Price",
      slug: "fixed-price-tab",
      bsTarget: "#fixed-price",
      icon: "ni-tags",
    },
    {
      id: 2,
      title: "Open for bids",
      slug: "open-for-bids-tab",
      bsTarget: "#open-for-bids",
      icon: "ni-file",
    },
  ],
  // previe item data
  previewItemData: {
    img: require("@/images/thumb/nft3.jpg"),
    title: "One Tribe Black Edition",
    byText: "By",
    authorText: "ZeniconStudio",
    authorLink: "/author",
    priceText: "Price",
    givenPrice: "$14.20",
    priceTextTwo: "Current bid",
    currentPrice: "0.000 ETH",
    btnText: "Place Bid",
    path: "/product-details-v1-1",
  },
  // prepaid-eth data
  prepaidData: {
    title: "Pre-Paid ETH Balance",
    content: "Balances can be withdrawn in ETH at anytime",
    contentTwo: "To increase your balance, send ETH to your deposit address below. ETH will be valued at USD market value at time of purchase. Gas fees will be subtracted from withdrawal amounts.",
    balances: [
      {
        id: 1,
        title: "Balance",
        price: "2 ETH",
        priceTwo: "$330.00 USD",
      },
      {
        id: 2,
        title: "Holds",
        price: "2 ETH",
        priceTwo: "$330.00 USD",
      },
    ],
  },
  // balance data
  balanceData: {
    title: "Balance:",
    price: "$330.00",
    titleTwo: "Holds:",
    priceTwo: "$330.00",
    content: "There is a $5,000 weekly cash out limit with a bank account.",
    btnText: "Connect A Bank Account",
    btns: [
      {
        title: "Cash out to Bank",
        btnClass: "btn-outline-primary",
        path: "",
      },
      {
        title: "View Cashout history",
        btnClass: "btn-light",
        path: "",
      },
    ],
  },
  // disply enfty data
  displayEnftyData: {
    mainTitle: "Display Enfties",
    content: 'New to displays? Learn more <a href="#">here</a>',
    titleTwo: "Connect New Display",
    btnText: "Add Display",
    titleThree: "Your Displays",
    btnTextTwo: "Display external Enfties",
    contentTwo: "Please allow for up to 40 seconds for your changes to be reflected on your display screen",
  },
  // redeem enfty data
  redeemEnftyData: {
    mainTitle: "Redeem Enfties",
    content: "Redemptions reward the top collectors of a particular artist by gifting them a nifty if a collector has a certain number of pieces from a particular collection on their account.",
    contentTwo: "To see if you are eligible, just select a redemption below!",
    titleTwo: "Redeem Enfty",
    contentThree: "Select the project you would like to redeem",
    contentFour: "All 5 available Enfties for redemption have been claimed",
  },
  // deposit data
  depositData: {
    mainTitle: "Deposit Enfties",
    content:
      'Only EnftyMart collection Enfties can be deposited. To check if your Enfty is eligible for deposit, click <a href="#" data-bs-toggle="modal" data-bs-target="#depositNiftyModal" class="btn-link">Here</a>',
    contentTwo: 'Metamask browser extension is required. Visit <a href="https://metamask.io/">metamask.io</a> to learn more.',
    btnText: "Connect a new wallet",
    btnLink: "wallet",
  },
  depositNiftyModal: {
    title: "Deposit Enfty",
    content: "Only Enfties registered in Enfty Gateway collections can be deposited. Check if your Enfty is compatible below:",
    img: require("@/images/thumb/qrcode.png"),
    contentTwo: "Scan QR code or send your nifty to the address above",
    contentThree: "Do not send cryptocurrency to this address",
    btnText: "Check",
  },
  deleteModal: {
    title: "Your item will be deleted permanently!",
    titleTwo: "Your card will be deleted permanently!",
    content: "Are you sure you want to delete item?",
    img: require("@/images/thumb/exclamation-circle-solid.svg"),
    btnText: "Cancel",
    btnTextTwo: "Ok Delete",
  },
  // about hero data
  aboutData: {
    title: "Building an open digital economy",
    content:
      "At EnftyMart, we're excited about a brand new type of digital good called a non-fungible token, or NFT. NFTs have exciting new properties: they’re unique, provably scarce, tradeable, and usable across multiple applications. Just like physical goods, you can do whatever you want with them! You could throw them in the trash, gift them to a friend a",
    contentTwo:
      "A core part of our vision is that open protocols like Ethereum and interoperable standards like ERC-721 and ERC-1155 will enable vibrant new economies. We're building tools that allow consumers to trade their assets freely",
    contentThree: "We’re proud to be the first and largest marketplace for NFTs.",
    img: require("@/images/thumb/nft-img-2.png"),
  },
  aboutDataTwo: {
    title: "About the EnftyMart",
    content: "EnftyMart was founded with a very simple mission - to make Enfties accessible to everyone",
    contentTwo:
      "In 2017 the world witnessed the birth of CryptoKitties. For the first time, the world experienced a decentralized application built on blockchains but targetted towards a mainstream audience.",
    contentThree: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, quasi consectetur. Et delectus minus saepe cumque qui harum! Aperiam, dolorem itaque!",
    contentFour: "Today, <strong>we’re proud to remain the largest general marketplace for user-owned digital items</strong>, supporting multiple blockchains, with the broadest set of categories",
    img: require("@/images/thumb/about-img.jpg"),
  },
  brandData: {
    title: "Backed by top firms & industry leaders",
    content: "Who are helping us pave the way towards a brand new digital economy",
    brandList: [
      {
        id: 1,
        img: require("@/images/brand/brand.png"),
        itemToShow: "show",
      },
      {
        id: 2,
        img: require("@/images/brand/brand-2.png"),
        itemToShow: "show",
      },
      {
        id: 3,
        img: require("@/images/brand/brand-3.png"),
        itemToShow: "show",
      },
      {
        id: 4,
        img: require("@/images/brand/brand-2.png"),
        itemToShow: "show",
      },
      {
        id: 5,
        img: require("@/images/brand/brand-3.png"),
      },
      {
        id: 6,
        img: require("@/images/brand/brand-4.png"),
      },
      {
        id: 7,
        img: require("@/images/brand/brand.png"),
      },
      {
        id: 8,
        img: require("@/images/brand/brand-2.png"),
      },
      {
        id: 9,
        img: require("@/images/brand/brand-3.png"),
      },
      {
        id: 10,
        img: require("@/images/brand/brand-4.png"),
      },
      {
        id: 11,
        img: require("@/images/brand/brand.png"),
      },
      {
        id: 12,
        img: require("@/images/brand/brand.png"),
      },
    ],
  },
  teamData: {
    title: "With some of the most forward-thinking angels",
    content: "Who are just as passionate about this space as we are",
    teamList: [
      {
        id: 1,
        img: require("@/images/client/a.jpg"),
        title: "Jessica brown",
        meta: "Co-founder of Scalar",
      },
      {
        id: 2,
        img: require("@/images/client/b.jpg"),
        title: "Tim Ferris",
        meta: "Entrepreneur",
      },
      {
        id: 3,
        img: require("@/images/client/c.jpg"),
        title: "Belinda Johnson",
        meta: "Attorney of Airbnb",
      },
      {
        id: 4,
        img: require("@/images/client/d.jpg"),
        title: "Justin Kan",
        meta: "Co-founder of Twitch",
      },
      {
        id: 5,
        img: require("@/images/client/e.jpg"),
        title: "Alexis Ohanian",
        meta: "Co-founder of Reddit",
      },
      {
        id: 6,
        img: require("@/images/client/f.jpg"),
        title: "Balaji Srinivisan",
        meta: "Entrepreneur",
      },
    ],
  },
  // ranking data
  rankingData: {
    tableHead: ["Collection", "Volume", "24h %", "7d %", "Floor Price", "Owners", "Assets"],
    tableBody: [
      {
        id: 1,
        path: "",
        img: require("@/images/thumb/avatar.jpg"),
        authorName: "Patternlicious",
        numText: "6,593.91",
        numTextTwo: "33.78%",
        numTextThree: "22.32%",
        numTextFour: "4.5",
        numTextFive: "6.5k",
        numTextSix: "53.3k",
      },
      {
        id: 2,
        path: "",
        img: require("@/images/thumb/avatar-2.jpg"),
        authorName: "Cartoonism",
        numText: "6,593.91",
        numTextTwo: "33.78%",
        numTextThree: "22.32%",
        numTextFour: "4.5",
        numTextFive: "6.5k",
        numTextSix: "53.3k",
      },
      {
        id: 3,
        path: "",
        img: require("@/images/thumb/avatar-3.jpg"),
        authorName: "Virtuland",
        numText: "6,593.91",
        numTextTwo: "33.78%",
        numTextThree: "22.32%",
        numTextFour: "4.5",
        numTextFive: "6.5k",
        numTextSix: "53.3k",
      },
      {
        id: 4,
        path: "",
        img: require("@/images/thumb/avatar-3.jpg"),
        authorName: "RockToonz",
        numText: "6,593.91",
        numTextTwo: "33.78%",
        numTextThree: "22.32%",
        numTextFour: "4.5",
        numTextFive: "6.5k",
        numTextSix: "53.3k",
      },
      {
        id: 5,
        path: "",
        img: require("@/images/thumb/avatar-5.jpg"),
        authorName: "CoolThings",
        numText: "6,593.91",
        numTextTwo: "33.78%",
        numTextThree: "22.32%",
        numTextFour: "4.5",
        numTextFive: "6.5k",
        numTextSix: "53.3k",
      },
      {
        id: 6,
        path: "",
        img: require("@/images/thumb/avatar-6.jpg"),
        authorName: "DigiPunks",
        numText: "6,593.91",
        numTextTwo: "33.78%",
        numTextThree: "22.32%",
        numTextFour: "4.5",
        numTextFive: "6.5k",
        numTextSix: "53.3k",
      },
    ],
  },
  // wallet data
  walletData: [
    {
      id: 1,
      img: require("@/images/brand/metamask.svg"),
      title: "Metamask",
      content: "Start exploring blockchain applications in seconds. Trusted by over 1 million users worldwide.",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 2,
      img: require("@/images/brand/bitski.svg"),
      title: "Bitski",
      content: "Bitski connects communities, creators and brands through unique, ownable digital content.",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 3,
      img: require("@/images/brand/fortmatic.svg"),
      title: "Fortmatic",
      content: "Let users access your Ethereum app from anywhere. No more browser extensions ellipsis.",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 4,
      img: require("@/images/brand/torus.svg"),
      title: "Torus",
      content: "Open source protocol for connecting decentralised applications to mobile wallets.",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 5,
      img: require("@/images/brand/coinbase.svg"),
      title: "Coinbase",
      content: "The easiest and most secure crypto wallet. No Coinbase account required to connect EnftyMart.",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 6,
      img: require("@/images/brand/wallet-connect.svg"),
      title: "WalletConnect",
      content: "Open source protocol for connecting decentralised applications to mobile wallets.",
      btnText: "Connect",
      path: "login",
    },
  ],
  walletDataTwo: [
    {
      id: 1,
      img: require("@/images/brand/metamask.svg"),
      title: "Metamask",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 2,
      img: require("@/images/brand/bitski.svg"),
      title: "Bitski",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 3,
      img: require("@/images/brand/fortmatic.svg"),
      title: "Fortmatic",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 4,
      img: require("@/images/brand/torus.svg"),
      title: "Torus",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 5,
      img: require("@/images/brand/coinbase.svg"),
      title: "Coinbase",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 6,
      img: require("@/images/brand/wallet-connect.svg"),
      title: "WalletConnect",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 7,
      img: require("@/images/brand/bitski.svg"),
      title: "Portis",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 8,
      img: require("@/images/brand/wallet-connect.svg"),
      title: "Fortmatic",
      btnText: "Connect",
      path: "login",
    },
    {
      id: 9,
      img: require("@/images/brand/wallet-connect.svg"),
      title: "Kaikas",
      btnText: "Connect",
      path: "login",
    },
  ],
  commentData: {
    title: "3 Comments",
    commentList: [
      {
        id: 1,
        title: "Olivia",
        img: require("@/images/thumb/avatar.jpg"),
        date: "15 January 2020",
        content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
        btnText: "Reply",
        replyList: [
          {
            id: 1,
            title: "John Smith",
            img: require("@/images/thumb/avatar-2.jpg"),
            date: "23 Feb 2020",
            content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
            btnText: "Reply",
          },
        ],
      },
      {
        id: 2,
        title: "Mark Hardson",
        img: require("@/images/thumb/avatar-3.jpg"),
        date: "22 Jun 2020",
        content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
        btnText: "Reply",
      },
    ],
  },
  formData: {
    title: "Leave a Comment",
    content: "Your email address will not be published. Required fields are marked *",
  },
  loginData: {
    title: "登陆",
    btnText: "现在就登陆",
    haveAccountText: "我没有账号",
    btnTextTwo: "注册",
    btnTextLink: "register",
    btns: [
      {
        title: "Google",
        btnClass: "bg-red-100 text-red g-btn",
        icon: "ni-google",
        path: "",
      },
      {
        title: "Facebook",
        btnClass: "bg-blue-100 text-blue f-btn",
        icon: "ni-facebook-f",
        path: "",
      },
      {
        title: "Twitter",
        btnClass: "bg-cyan-100 text-cyan t-btn",
        icon: "ni-twitter",
        path: "",
      },
    ],
  },
  // login tab nav
  loginTabNav: [
    {
      id: 1,
      isActive: "active",
      img: require("@/images/brand/metamask.svg"),
      title: "MetaMask",
      slug: "meta-mask-tab",
      bsTarget: "#meta-mask",
    },
    {
      id: 2,
      img: require("@/images/brand/wallet-connect.svg"),
      title: "Walletconnect",
      slug: "wallet-connect-tab",
      bsTarget: "#wallet-connect",
    },
  ],
  // // login data two
  // loginDataTwo: {
  //   title: "Connect Your MetaMask Wallet",
  //   titleTwo: "Connect Your Walletconnect Wallet",
  //   btnText: "Sign In",
  //   btnTextTwo: "Learn how to use MetaMask Wallet",
  //   btnTextThree: "Learn how to use Walletconnect Wallet",
  //   btnTextLink: "",
  //   btnLink: "login",
  // },
  // register data
  registerData: {
    img: require("@/images/thumb/remote-2.png"),
    title: '注册<span class="text-primary">YOOCH</span>',
    subTitle: "填写以下字段以创建帐户",
    termText: "注册即表示您同意我们的条款和条件以及隐私政策",
    btnText: "创建账号",
    haveAccountText: "账号已经存在",
    btnTextTwo: "去登陆",
    btnTextLink: "login",
    btns: [
      {
        title: "Google",
        btnClass: "bg-red-100 text-red g-btn",
        icon: "ni-google",
        path: "",
      },
      {
        title: "Facebook",
        btnClass: "bg-blue-100 text-blue f-btn",
        icon: "ni-facebook-f",
        path: "",
      },
      {
        title: "Twitter",
        btnClass: "bg-cyan-100 text-cyan t-btn",
        icon: "ni-twitter",
        path: "",
      },
    ],
  },
  // contact data
  contactData: {
    title: "Contact Us",
    titleTwo: "Find Us There",
    subTitle: "Have a question? Need help? Don't hesitate, drop us a line",
    btnText: "Send Message",
    content: "Collaboratively administrate channels whereas virtual. Objectively seize scalable metrics whereas proactive e-services.",
    contactList: [
      {
        id: 1,
        icon: "ni-mobile",
        title: "Phone:",
        subTitle: "(123) 123-456",
      },
      {
        id: 2,
        icon: "ni-globe",
        title: "Web:",
        subTitle: "www.softnio.com",
      },
      {
        id: 3,
        icon: "ni-mail",
        title: "Email:",
        subTitle: "office@softnio.com",
      },
    ],
  },
  sidebarData: {
    sidebarWidget: {
      title: "Search",
      inputText: "Search post",
    },
    sidebarWidgetTwo: {
      title: "Kamran Ahmed",
      img: require("@/images/thumb/avatar-4.jpg"),
      content: "I make art with the simple goal of giving you something pleasing to look at for a few seconds.",
      icons: [
        {
          id: 1,
          icon: "ni-facebook-f",
          path: "",
        },
        {
          id: 2,
          icon: "ni-twitter",
          path: "",
        },
        {
          id: 3,
          icon: "ni-instagram",
          path: "",
        },
        {
          id: 4,
          icon: "ni-pinterest",
          path: "",
        },
      ],
    },
    sidebarWidgetThree: {
      title: "Categories",
      catList: [
        {
          id: 1,
          title: "Art",
          path: "/blog",
        },
        {
          id: 2,
          title: " Virtual Worlds",
          path: "/blog",
        },
        {
          id: 3,
          title: "Collectibles",
          path: "/blog",
        },
        {
          id: 4,
          title: "Music",
          path: "/blog",
        },
        {
          id: 5,
          title: "Games",
          path: "/blog",
        },
        {
          id: 6,
          title: "Domains",
          path: "/blog",
        },
        {
          id: 7,
          title: "Memes",
          path: "/blog",
        },
      ],
    },
    sidebarWidgetFour: {
      title: "Recent Post",
      postList: [
        {
          id: 1,
          img: require("@/images/thumb/small-img.jpg"),
          title: "Announcing Our $100m Raise",
          date: "July 13, 2021",
          path: "/blog",
        },
        {
          id: 2,
          img: require("@/images/thumb/small-img-2.jpg"),
          title: "Edition365: A Portrait Of The Year That",
          date: "July 13, 2021",
          path: "/blog",
        },
        {
          id: 3,
          img: require("@/images/thumb/small-img-3.jpg"),
          title: "Artist interview: Arran Schonberg",
          date: "July 13, 2021",
          path: "/blog",
        },
      ],
    },
    sidebarWidgetFive: {
      title: "Tags",
      tagList: [
        {
          id: 1,
          title: "Virtual World",
          path: "/blog",
        },
        {
          id: 2,
          title: "Art",
          path: "/blog",
        },
        {
          id: 3,
          title: "Vision",
          path: "/blog",
        },
        {
          id: 4,
          title: "Music",
          path: "/blog",
        },
        {
          id: 5,
          title: "Domains",
          path: "/blog",
        },
        {
          id: 6,
          title: "Print",
          path: "/blog",
        },
        {
          id: 7,
          title: "Programming",
          path: "/blog",
        },
      ],
    },
  },
  // profile data
  profileData: {
    title: "你的库存",
    items: [
      {
        id: 1,
        img: require("@/images/thumb/nft-2.jpg"),
        title: "One Tribe Black Edition",
        byText: "By",
        authorText: "ZeniconStudio",
        authorLink: "/author",
        priceText: "Price",
        givenPrice: "$14.20",
        priceTextTwo: "Current bid",
        currentPrice: "1.32 ETH",
        btnText: "Place Bid",
        path: "/product-details-v1-1",
      },
      {
        id: 2,
        img: require("@/images/thumb/nft3.jpg"),
        title: "Operation Jade Fury",
        byText: "By",
        authorText: "ZeniconStudio",
        authorLink: "/author",
        priceText: "Price",
        givenPrice: "$14.20",
        priceTextTwo: "Current bid",
        currentPrice: "1.32 ETH",
        btnText: "Place Bid",
        path: "/product-details-v1-1",
        btnTextTwo: "Follow",
      },
      {
        id: 3,
        img: require("@/images/thumb/nft4.jpg"),
        title: "Unboxing The Compass",
        byText: "By",
        authorText: "ZeniconStudio",
        authorLink: "/author",
        priceText: "Price",
        givenPrice: "$14.20",
        priceTextTwo: "Current bid",
        currentPrice: "1.32 ETH",
        btnText: "Place Bid",
        path: "/product-details-v1-1",
        btnTextTwo: "Follow",
      },
      {
        id: 4,
        img: require("@/images/thumb/nft5.jpg"),
        title: "Rendering by the Water",
        byText: "By",
        authorText: "ZeniconStudio",
        authorLink: "/author",
        priceText: "Price",
        givenPrice: "$14.20",
        priceTextTwo: "Current bid",
        currentPrice: "1.32 ETH",
        btnText: "Place Bid",
        path: "/product-details-v1-1",
        btnTextTwo: "Follow",
      },
      {
        id: 5,
        img: require("@/images/thumb/nft6.jpg"),
        title: "Divine Opulence",
        byText: "By",
        authorText: "DvisionNetwork",
        authorLink: "/author",
        priceText: "Price",
        givenPrice: "$12.00",
        priceTextTwo: "Current bid",
        currentPrice: "1.44 ETH",
        btnText: "Place Bid",
        path: "/product-details-v1-1",
        btnTextTwo: "Follow",
      },
      {
        id: 6,
        img: require("@/images/thumb/nft7.jpg"),
        title: "Sacral Metatron Cube",
        byText: "By",
        authorText: "KamranMedia",
        authorLink: "/author",
        priceText: "Price",
        givenPrice: "$11.00",
        priceTextTwo: "Current bid",
        currentPrice: "2.33 ETH",
        btnText: "Place Bid",
        path: "/product-details-v1-1",
        btnTextTwo: "Follow",
      },
    ],
  },
  // filter cat data
  filterCatData: {
    title: "Category",
    catList: [
      {
        class: "active",
        title: "All",
        path: "",
      },
      {
        title: "Artworks",
        path: "",
      },
      {
        title: "Photography",
        path: "",
      },
      {
        title: "Games",
        path: "",
      },
      {
        title: "Metaverses",
        path: "",
      },
      {
        title: "Music",
        path: "",
      },
      {
        title: "Memes",
        path: "",
      },
      {
        title: "Punks",
        path: "",
      },
      {
        title: "Domains",
        path: "",
      },
    ],
  },
  socialShareList: [
    {
      title: "Facebook",
      path: "",
      btnClass: "ni-facebook-f",
    },
    {
      title: "Twitter",
      path: "",
      btnClass: "ni-twitter",
    },
    {
      title: "Instagram",
      path: "",
      btnClass: "ni-instagram",
    },
    {
      title: "Email",
      path: "",
      btnClass: "ni-emails",
    },
  ],
  placeBidModal: {
    title: "Place a Bid",
    content: "You are about to place a bid for <strong>The Future is Blossoming - Harlows 2021</strong> from <strong>Nathan walls</strong>",
    labelText: "Your bid (ETH)",
    labelTextTwo: 'Enter quantity <span class="text-primary">5 available</span>',
    totalBidList: [
      {
        title: "Your bidding balance",
        price: "0.013325 ETH",
      },
      {
        title: "Your balance",
        price: "10.67856 ETH",
      },
      {
        title: "Service fee 3.5%",
        price: "0.00325 ETH",
      },
      {
        title: "You will pay",
        price: "0.013325 ETH",
      },
    ],
    btnText: "Place a Bid",
    btnLink: "wallet",
  },
  // eslint-disable-next-line no-dupe-keys
  placeBidModal: {
    title: "Place a Bid",
    content: "You are about to place a bid for <strong>The Future is Blossoming - Harlows 2021</strong> from <strong>Nathan walls</strong>",
    labelText: "Your bid (ETH)",
    labelTextTwo: 'Enter quantity <span class="text-primary">5 available</span>',
    totalBidList: [
      {
        title: "Your bidding balance",
        price: "0.013325 ETH",
      },
      {
        title: "Your balance",
        price: "10.67856 ETH",
      },
      {
        title: "Service fee 3.5%",
        price: "0.00325 ETH",
      },
      {
        title: "You will pay",
        price: "0.013325 ETH",
      },
    ],
    btnText: "Place a Bid",
    btnLink: "wallet",
  },
  reportModalData: {
    title: "Why are you reporting?",
    content: "If you believe there's been a violation of EnftyMart's Terms of Service or Community Guidelines, please complete this report.",
    contentTwo: 'For all cases related to potential copyright infringement, please email <a href="mailto:trust@enftymart.com">trust@enftymart.com</a> directly with a formal DMCA Takedown Request.',
    placeholderText: "Describe why you think this page should be removed from EnftyMart.",
    btnText: "Submit",
  },
  followersModal: {
    title: "Why are you reporting?",
    btnText: "Following",
    btnTextTwo: "Followers",
    followingList: [
      {
        id: 1,
        title: "Alex Smith",
        userName: "@alex_smith",
        path: "",
        avatar: require("@/images/thumb/avatar-4.jpg"),
        btnText: "Follow",
      },
      {
        id: 2,
        title: "Digital Monkey",
        userName: "@digital_monkey",
        path: "",
        avatar: require("@/images/thumb/avatar.jpg"),
        btnText: "Follow",
      },
      {
        id: 3,
        title: "Beejaey",
        userName: "@beejaey",
        path: "",
        avatar: require("@/images/thumb/avatar-2.jpg"),
        btnText: "Follow",
      },
      {
        id: 4,
        title: "Tom Dracula",
        userName: "@tom_dracula",
        path: "",
        avatar: require("@/images/thumb/avatar-3.jpg"),
        btnText: "Follow",
      },
      {
        id: 5,
        title: "Kevin Martin",
        userName: "@kevin_martin",
        path: "",
        avatar: require("@/images/thumb/avatar-5.jpg"),
        btnText: "Follow",
      },
    ],
    followerList: [
      {
        id: 1,
        title: "Digital Monkey",
        userName: "@digital_monkey",
        path: "",
        avatar: require("@/images/thumb/avatar.jpg"),
        btnText: "Follow",
      },
      {
        id: 2,
        title: "Beejaey",
        userName: "@beejaey",
        path: "",
        avatar: require("@/images/thumb/avatar-2.jpg"),
        btnText: "Follow",
      },
      {
        id: 3,
        title: "Tom Dracula",
        userName: "@tom_dracula",
        path: "",
        avatar: require("@/images/thumb/avatar-3.jpg"),
        btnText: "Follow",
      },
      {
        id: 4,
        title: "Kevin Martin",
        userName: "@kevin_martin",
        path: "",
        avatar: require("@/images/thumb/avatar-5.jpg"),
        btnText: "Follow",
      },
      {
        id: 5,
        title: "Alex Smith",
        userName: "@alex_smith",
        path: "",
        avatar: require("@/images/thumb/avatar-4.jpg"),
        btnText: "Follow",
      },
    ],
  },
  // activity nav list
  activityNavList: [
    {
      id: 1,
      class: "active",
      icon: require("@/images/thumb/all.svg"),
      title: "All",
      slug: "all-tab",
      bsTarget: "#all",
    },
    {
      id: 2,
      icon: require("@/images/thumb/art.svg"),
      title: "Art",
      slug: "art-tab",
      bsTarget: "#art",
    },
    {
      id: 3,
      icon: require("@/images/thumb/virtual-world.svg"),
      title: "Virtual Worlds",
      slug: "virtual-worlds-tab",
      bsTarget: "#virtual-worlds",
    },
    {
      id: 4,
      icon: require("@/images/thumb/icon4.svg"),
      title: "Trending Cards",
      slug: "trending-cards-tab",
      bsTarget: "#trending-cards",
    },
    {
      id: 5,
      icon: require("@/images/thumb/icon5.svg"),
      title: "Collectibles",
      slug: "collectibles-tab",
      bsTarget: "#collectibles",
    },
    {
      id: 6,
      icon: require("@/images/thumb/icon6.svg"),
      title: "Utility",
      slug: "utility-tab",
      bsTarget: "#utility",
    },
  ],
  // activity table head
  activityTableHead: ["Event", "Item", "Unit Price", "Quantity", "From", "To", "Date"],
  // activity table body
  activityTableBody: {
    tableBodyList: [
      {
        id: 1,
        eventTitle: "Created",
        itemTitle: 'The Cost" 09.27.2021, Debut Single',
        price: "0.001",
        quantity: 1,
        fromText: "	lucifer",
        toText: "MackMoli",
        dateText: "1 day ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 2,
        eventTitle: "Created",
        itemTitle: "Fragment",
        price: "-",
        quantity: 0,
        fromText: "NullAddress",
        toText: "ValourKnight	",
        dateText: "2 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 3,
        eventTitle: "Sale",
        itemTitle: "RSA Cannabis",
        price: "0.02",
        quantity: 1,
        fromText: "rohendra",
        toText: "amber",
        dateText: "3 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 4,
        eventTitle: "List",
        itemTitle: "Childhood Astronaut",
        price: "120",
        quantity: 1,
        fromText: "ValourKnight",
        toText: "noel",
        dateText: "4 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 5,
        eventTitle: "Bid",
        itemTitle: "Hunter x Hunter",
        price: "0.2",
        quantity: 1,
        fromText: "rohendra",
        toText: "ValourKnight	",
        dateText: "5 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 6,
        eventTitle: "Transfer",
        itemTitle: "HSong1",
        price: "0.002",
        quantity: 1,
        fromText: "lucifer",
        toText: "NullAddress",
        dateText: "1 week ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 7,
        eventTitle: "Bid Cancelled",
        itemTitle: "AN EPIC AUTOGRAPHED BOLLYWOOD FILM POSTER!",
        price: "-",
        quantity: 1,
        fromText: "0x_arr1975k_29",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 8,
        eventTitle: "Cancelled",
        itemTitle: "Sunset #1",
        price: "-",
        quantity: 1,
        fromText: "amber",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
    ],
    tableBodyListTwo: [
      {
        id: 1,
        eventTitle: "Created",
        itemTitle: "Cassanjo Project",
        price: "0.012",
        quantity: 1,
        fromText: "	lucifer",
        toText: "MackMoli",
        dateText: "1 day ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 2,
        eventTitle: "Created",
        itemTitle: "Blue teddy bear #23|50",
        price: "-",
        quantity: 0,
        fromText: "NullAddress",
        toText: "ValourKnight	",
        dateText: "2 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 3,
        eventTitle: "Sale",
        itemTitle: "RSA Cannabis",
        price: "0.02",
        quantity: 1,
        fromText: "rohendra",
        toText: "amber",
        dateText: "3 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 4,
        eventTitle: "List",
        itemTitle: "Childhood Astronaut",
        price: "120",
        quantity: 1,
        fromText: "ValourKnight",
        toText: "noel",
        dateText: "4 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 5,
        eventTitle: "Bid",
        itemTitle: "Hunter x Hunter",
        price: "0.2",
        quantity: 1,
        fromText: "rohendra",
        toText: "ValourKnight	",
        dateText: "5 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 6,
        eventTitle: "Transfer",
        itemTitle: "HSong1",
        price: "0.002",
        quantity: 1,
        fromText: "lucifer",
        toText: "NullAddress",
        dateText: "1 week ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 7,
        eventTitle: "Bid Cancelled",
        itemTitle: "AN EPIC AUTOGRAPHED BOLLYWOOD FILM POSTER!",
        price: "-",
        quantity: 1,
        fromText: "0x_arr1975k_29",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 8,
        eventTitle: "Cancelled",
        itemTitle: "Sunset #1",
        price: "-",
        quantity: 1,
        fromText: "amber",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
    ],
    tableBodyListThree: [
      {
        id: 1,
        eventTitle: "Created",
        itemTitle: "Deep Sea Phantasy",
        price: "0.001",
        quantity: 1,
        fromText: "	lucifer",
        toText: "MackMoli",
        dateText: "1 day ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 2,
        eventTitle: "Created",
        itemTitle: "Blue teddy bear #23|50",
        price: "-",
        quantity: 0,
        fromText: "NullAddress",
        toText: "ValourKnight	",
        dateText: "2 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 3,
        eventTitle: "Sale",
        itemTitle: "RSA Cannabis",
        price: "0.02",
        quantity: 1,
        fromText: "rohendra",
        toText: "amber",
        dateText: "3 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 4,
        eventTitle: "List",
        itemTitle: "Childhood Astronaut",
        price: "120",
        quantity: 1,
        fromText: "ValourKnight",
        toText: "noel",
        dateText: "4 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 5,
        eventTitle: "Bid",
        itemTitle: "Hunter x Hunter",
        price: "0.2",
        quantity: 1,
        fromText: "rohendra",
        toText: "ValourKnight	",
        dateText: "5 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 6,
        eventTitle: "Transfer",
        itemTitle: "HSong1",
        price: "0.002",
        quantity: 1,
        fromText: "lucifer",
        toText: "NullAddress",
        dateText: "1 week ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 7,
        eventTitle: "Bid Cancelled",
        itemTitle: "AN EPIC AUTOGRAPHED BOLLYWOOD FILM POSTER!",
        price: "-",
        quantity: 1,
        fromText: "0x_arr1975k_29",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 8,
        eventTitle: "Cancelled",
        itemTitle: "Sunset #1",
        price: "-",
        quantity: 1,
        fromText: "amber",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
    ],
    tableBodyListFour: [
      {
        id: 1,
        eventTitle: "Created",
        itemTitle: "Cute Astronout",
        price: "0.012",
        quantity: 1,
        fromText: "	lucifer",
        toText: "MackMoli",
        dateText: "1 day ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 2,
        eventTitle: "Created",
        itemTitle: "Blue teddy bear #23|50",
        price: "-",
        quantity: 0,
        fromText: "NullAddress",
        toText: "ValourKnight	",
        dateText: "2 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 3,
        eventTitle: "Sale",
        itemTitle: "RSA Cannabis",
        price: "0.02",
        quantity: 1,
        fromText: "rohendra",
        toText: "amber",
        dateText: "3 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 4,
        eventTitle: "List",
        itemTitle: "Childhood Astronaut",
        price: "120",
        quantity: 1,
        fromText: "ValourKnight",
        toText: "noel",
        dateText: "4 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 5,
        eventTitle: "Bid",
        itemTitle: "Hunter x Hunter",
        price: "0.2",
        quantity: 1,
        fromText: "rohendra",
        toText: "ValourKnight	",
        dateText: "5 days ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 6,
        eventTitle: "Transfer",
        itemTitle: "HSong1",
        price: "0.002",
        quantity: 1,
        fromText: "lucifer",
        toText: "NullAddress",
        dateText: "1 week ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 7,
        eventTitle: "Bid Cancelled",
        itemTitle: "AN EPIC AUTOGRAPHED BOLLYWOOD FILM POSTER!",
        price: "-",
        quantity: 1,
        fromText: "0x_arr1975k_29",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
      {
        id: 8,
        eventTitle: "Cancelled",
        itemTitle: "Sunset #1",
        price: "-",
        quantity: 1,
        fromText: "amber",
        toText: "",
        dateText: "3 weeks ago",
        fromLink: "",
        toLink: "",
      },
    ],
  },
  // footer data
  footerData: {
    content: "立志做出大家喜欢的公共空间，让所有人都可以看见你的热爱，不负热爱一场",
    footerList: [
      {
        id: 1,
        title: "市场",
        navList: [
          {
            title: "所有作品",
            path: "/explore",
          },
          {
            title: "作品块",
            path: "/explore",
          }
        ],
      },
      {
        id: 2,
        title: "我的空间",
        navList: [
          {
            title: "个人空间",
            path: "/",
          },
          {
            title: "我的仓库",
            path: "/",
          },
          {
            title: "出售 & 购买",
            path: "/",
          },
        ],
      },
      {
        id: 3,
        title: "YOOCH",
        navList: [
          {
            title: "关于",
            path: "/",
          },
          {
            title: "博客",
            path: "/",
          },
          {
            title: "联系我",
            path: "/",
          },
          {
            title: "支持我",
            path: "/",
          },
        ],
      },
    ],
    footerListTwo: [
      {
        title: "探索",
        path: "/explore",
      },
      {
        title: "登陆",
        path: "login",
      },
    ],
  },
  createNftModal: {
    title: "Confirm Your Registration",
    content: "Before this item gets created, please <strong>typing your Private Key</strong> if you'd like to confirm.",
    labelText: "Private Key",
    // btnLink: "wallet",
  },
  copyTitle: 'Copyright © 2022 EnftyMart. Template Made by <a href="https://themeforest.net/user/softnio/portfolio" target="_blank">Softnio</a>',
};

export default SectionData;
